import { useState, useEffect, useContext, useRef, act } from 'react';
import { useNavigate, useSearchParams, useParams, useLocation } from "react-router-dom";
import { Box, Stepper, Button, CircularProgress, LinearProgress } from '@mui/material';

import Question from '../../Components/Questions/Questions.jsx';
import ProgressBar from '../../Components/ProgressBar/ProgressBar.jsx';
import ProgressBarSingle from '../../Components/ProgressBarSingle/ProgressBarSingle.jsx';

import prevArrow from '../../Assets/Images/prev-arrow.svg';
import nextArrow from '../../Assets/Images/leftArrow.svg';
import nextArrowWhite from '../../Assets/Images/next-arrow-white.svg';
import useWindowDimensions from '../../Hooks/useWindowDimensions';
import useEnsureAssessmentDetails from '../../Hooks/useEnsureAssessmentDetails';
// import AssessmentProgressContext from '../Store/AssessmentProgressContext';
import AssessmentQuestionContext from '../../Store/AssessmentQuestionContext';
import QuestionsProgressContext from '../../Store/QuestionsProgressContext';
import questionTitles from '../../temp.js';
import leftArrowIcon from '../../Assets/Images/leftArrowIcone.svg'
import rightArrowIcon from '../../Assets/Images/rightArrowIcon.svg'

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { m } from 'framer-motion';
import { leader_reset_payload_round1, leader_reset_payload_round2, starter_reset_payload_round1, starter_reset_payload_round2, starterMostPayload, starterPayload } from './ResetPayload.js';
import { TroubleshootRounded } from '@mui/icons-material';
import { updateAssessmentStatus, sendNotifications, fetchAssessmentProgress, updateAssessmentProgress } from '../../api/index.js';
import PauseScreen from '../PauseScreen/PauseScreen.jsx';
import { isEqual, last } from 'lodash';

const AssessmentV3 = () => {

  // const assessProgressCtx = useContext(AssessmentProgressContext);
  // console.log("assessProgressCtx", assessProgressCtx);
  const assessCtx = useContext(AssessmentQuestionContext);
  const questionsCtx = useContext(QuestionsProgressContext);
  const { windowWidth } = useWindowDimensions();
  let navigate = useNavigate();
  const { id, pageId } = useParams();
  const isMostLs = localStorage.getItem(`isMost-${id}`) == 'true' ? true : localStorage.getItem(`isMost-${id}`) == 'false' ? false : null;
  const [isMost, setIsMost] = useState(isMostLs || null)
  const [hasLeader, setHasLeader] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  useEnsureAssessmentDetails(id, searchParams);
  const [backFromTieBreaker, setBackFromTieBreaker] = useState(false)
  const [backButtonClicked, setBackButtonClicked] = useState(false)
  const [autoSubmit, setAutoSubmit] = useState(false)
  const [clientId, setClientId] = useState(null)
  const [progressBack, setProgressBack] = useState(false)
  const [progressNext, setProgressNext] = useState(false)
  const [client_id, setClient_id] = useState(null)
  const [hasNotified, setHasNotified] = useState(false)
  const [isPauseScreen, setIsPauseScreen] = useState(false)

  const location = useLocation()
  // const respondentName = new URLSearchParams(window.location.search);

  const [leader, setLeader] = useState(null);
  const [member, setMember] = useState(null);
  const [selfUserName, setSelfUserName] = useState(null)
  const [userName, setUserName] = useState(null)
  const [nextPageIdParam, setNextPageIdParam] = useState(searchParams.get("next_page"))
  const [isLoading, setIsLoading] = useState(true);
  const [activeStep, setActiveStep] = useState(0);
  const [prevValue, setPrevValue] = useState(0);
  const [nextValue, setNextValue] = useState(0);
  const [sections, setSections] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [questionCount, setQuestionCount] = useState(0);
  const [currentHash, setCurrentHash] = useState(0);
  const [hasAdditional, setHasAdditional] = useState(false);
  const [qs, setQs] = useState([]);
  const [fetchedQuestions, setFetchedQuestions] = useState()
  const [showNextBtn, setShowNextBtn] = useState(false);
  const [prevBtnClicked, setPrevBtnClicked] = useState(false);
  const [resultData, setResultData] = useState([]);
  const [variableMapArray, setVariableMapArray] = useState([])
  const [tieBreakerId, setTieBreakerId] = useState();
  const [ieBreakers, setTieBreakers] = useState()
  const [tieBreakersLeaderShip, setTieBreakersLeaderShip] = useState()
  const [isCompleteAssessmentCalled, setIsCompleteAssessmentCalled] = useState(false)
  const [tiebreakerQuestionCount, setTiebreakerQuestionCount] = useState(0)
  const [questionType, setQuestionType] = useState("")
  const [starterMostScores, setStarterMostScores] = useState([])
  const [leadershipMostScores, setLeadershipMostScores] = useState([])
  const [hasVisited, setHasVisited] = useState(0)
  const [paramData, setParamData] = useState({})
  
  const markAssessmentCompletedRef = useRef(false)

  const selectedRole = localStorage.getItem("selectedRole");
  const isLastAsmt = JSON.parse(localStorage.getItem(`searchParams-${id}`))?.isLastAsmt;

  const threeWaytieBreakersPageIdArray = [955, 956, 957, 958]
  const twoWaytieBreakersPageIdArray = [949, 959, 966, 967, 968, 969, 970]
  const twoWaytieBreakersPageIdArrayRound2 = [985, 986, 987, 989, 990, 978]

  const threeWaytieBreakersPageIdArrayLeadership = [960, 961, 962, 963]
  const twoWaytieBreakersPageIdArrayLeadership = [965, 964, 971, 964, 972, 973, 974, 975]
  const twoWaytieBreakersPageIdArrayRound2Leadership = [984, 996, 997, 998, 999, 1000, 1001]

  const heart_r1_m = variableMapArray["heart_round1_m"];
  const soul_round1_m = variableMapArray["soul_round1_m"];
  const mind_round1_m = variableMapArray["mind_round1_m"];
  const strength_round1_m = variableMapArray["str_round1_m"];

  const heart_r1_l = variableMapArray["heart_round1_l"];
  const soul_round1_l = variableMapArray["soul_round1_l"];
  const mind_round1_l = variableMapArray["mind_round1_l"];
  const strength_round1_l = variableMapArray["str_round1_l"];

  let testingVarsM = [heart_r1_m, soul_round1_m, mind_round1_m, strength_round1_m];
  let testingVarsL = [heart_r1_l, soul_round1_l, mind_round1_l, strength_round1_l];

  const heart_r2_m = variableMapArray["heart_round2_m"];
  const soul_round2_m = variableMapArray["soul_round2_m"];
  const mind_round2_m = variableMapArray["mind_round2_m"];
  const strength_round2_m = variableMapArray["str_round2_m"];

  const heart_r2_l = variableMapArray["heart_round2_l"];
  const soul_round2_l = variableMapArray["soul_round2_l"];
  const mind_round2_l = variableMapArray["mind_round2_l"];
  const strength_round2_l = variableMapArray["str_round2_l"];

  let testingVarsM2 = [heart_r2_m, soul_round2_m, mind_round2_m, strength_round2_m];
  let testingVarsL2 = [heart_r2_l, soul_round2_l, mind_round2_l, strength_round2_l];

  const perform_r1_m = variableMapArray["per_round1_m"];
  const vision_r1_m = variableMapArray["vis_round1_m"];
  const strategy_r1_m = variableMapArray["strat_round1_m"]
  const collab_r1_m = variableMapArray["col_round1_m"];

  const perform_r1_l = variableMapArray["per_round1_l"];
  const vision_r1_l = variableMapArray["vis_round1_l"];
  const strategy_r1_l = variableMapArray["strat_round1_l"]
  const collab_r1_l = variableMapArray["col_round1_l"];

  let testingVarsMLeadership = [perform_r1_m, strategy_r1_m, vision_r1_m, collab_r1_m];
  let testingVarsLLeadership = [perform_r1_l, strategy_r1_l, vision_r1_l, collab_r1_l];

  const perform_r2_m = variableMapArray["per_round2_m"];
  const vision_r2_m = variableMapArray["vis_round2_m"];
  const collab_r2_m = variableMapArray["col_round2_m"];
  const strategy_r2_m = variableMapArray["strat_round2_m"];

  // Least variables
  const perform_r2_l = variableMapArray["per_round2_l"];
  const vision_r2_l = variableMapArray["vis_round2_l"];
  const collab_r2_l = variableMapArray["col_round2_l"];
  const strategy_r2_l = variableMapArray["strat_round2_l"];

  const testingVarsMLeadershipRound2 = [perform_r2_m, strategy_r2_m, vision_r2_m, collab_r2_m];
  const testingVarsLLeadershipRound2 = [perform_r2_l, strategy_r2_l, vision_r2_l, collab_r2_l];

  const isTieBreaker = twoWaytieBreakersPageIdArray?.includes(parseInt(pageId)) || twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(pageId)) || twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(pageId)) || twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(pageId)) || threeWaytieBreakersPageIdArray?.includes(parseInt(pageId)) || threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(pageId))

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem(`searchParams-${id}`)) || {};
    setLeader(storedData.leader || null);
    setMember(storedData.member || null);
    // setHasLeader(!!storedData.leader);
    setSelfUserName(storedData.selfUserName || null)
    setUserName(storedData.userName || null)
    setClient_id(storedData.clientId || null)
    assessCtx?.setLeaderName(storedData.leader)
  }, []);

  const formattedLeader = leader
  ? leader
      ?.split(' ')
      ?.map(word =>
        word === word.toUpperCase()
          ? word
          : word
              ?.split('-')
              ?.map(
                part =>
                  part?.charAt(0)?.toUpperCase() + part?.slice(1)?.toLowerCase()
              )
              ?.join('-')
      )
      ?.join(' ')
  : '';

  const formattedMember = member
    ?.split(' ')
    ?.map(word =>
      word === word.toUpperCase()
        ? word
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    ?.join(' ');

  // console.log("pageId", pageId);

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem(`searchParams-${id}`)) || {};
    console.log('storedData', storedData)
    setParamData(storedData)
    if (!!storedData.leader) {
      setHasLeader(true);
    }

  }, [searchParams])

  let removeNextSearchParam = (_searchParams) => {
    const clonedParams = new URLSearchParams(_searchParams.toString());

    // Remove the 'next_page' parameter
    clonedParams.delete('next_page');

    // Return the modified clone
    return clonedParams;
  }


  useEffect(() => {
    // document.body.style.backgroundColor = "#E5E5E5";

    setIsLoading(true);
    setAutoSubmit(false); //resets after each pageid loads so that we can stop autosubmitting questions
    getQuestions();
    getResultsData()
    localStorage.removeItem("backFromDetailsPage");
    // setQs(questions);
    // if(id != null) {      
    //   getAssessment();
    // } else {
    //   getQuestions();
    // }

    // assessProgressCtx.updateMainSectionsStatus(assessProgressCtx?.mainSections?.map(sec => {
    //   if(sec.title === "Response") return { ...sec, status: "active" };
    //   else return { ...sec, status: "unfinished" };
    // }));

  }, [pageId]);

  useEffect(() => {
    localStorage.setItem(`isMost-${id}`, isMost)
    console.log("ismost", isMost)
  }, [isMost])

  useEffect(() => {
    const isMostLs = localStorage.getItem(`isMost-${id}`) == 'true' ? true : localStorage.getItem(`isMost-${id}`) == 'false' ? false : null;
    setIsMost(isMostLs)
    setNextPageIdParam(searchParams.get('next_page'));
  }, [])

  console.log("clientId", clientId)

  const putAssessmentStatus = async ({ assessmentId, deploymentId, status }) => {
    try {
      if (!assessmentId || !deploymentId || !status) {
        throw new Error('Something is missing!');
      }
      const urlParams = new URLSearchParams(window.location.search);
      const clientId = client_id;

      if (!clientId) {
        throw new Error('Client ID is missing in the URL!');
      }
      const apiUrl = `${process.env.REACT_APP_API_URI}/v5/organisations/tl/deployments/${clientId}/assessment/${assessmentId}`;

      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: status }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Failed to update assessment status:', error.message);
    }
  };

  // useEffect(() => {
  //   const updateStatusBasedOnURL = async () => {
  //     if (!clientId) return;
  //     const assessmentId = id;
  //     const deploymentId = clientId; 
  //     const status = location.pathname.includes("results") ? "complete" : "pending";

  //     await putAssessmentStatus({ assessmentId, deploymentId, status });
  //   };

  //   updateStatusBasedOnURL();
  // }, [location, clientId]);

  const getResultsData = async () => {
    setIsLoading(true)
    try {
      const API_URI = process.env.REACT_APP_API_URI;
      if (!API_URI) {
        throw new Error("API URI is not defined in environment variables.");
      }

      const response = await fetch(`${API_URI}/v3/user/assessment/${id}/results`, {
        method: "GET",
        mode: "cors",
        headers: { 'Content-Type': 'application/json' }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }

      setIsLoading(false)
      const data = await response.json();
      setResultData(data)

      const variableMap = data?.variables?.reduce((acc, el) => {
        acc[el.variable] = el.score;
        return acc;
      }, {});

      const heart_r1_m = variableMap["heart_round1_m"];
      const soul_round1_m = variableMap["soul_round1_m"];
      const mind_round1_m = variableMap["mind_round1_m"];
      const strength_round1_m = variableMap["str_round1_m"];

      const heart_r1_l = variableMap["heart_round1_l"];
      const soul_round1_l = variableMap["soul_round1_l"];
      const mind_round1_l = variableMap["mind_round1_l"];
      const strength_round1_l = variableMap["str_round1_l"];

      const perform_r1_m = variableMap["per_round1_m"];
      const vision_r1_m = variableMap["vis_round1_m"];
      const collab_r1_m = variableMap["col_round1_m"];
      const strategy_r1_m = variableMap["strat_round1_m"];

      const perform_r1_l = variableMap["per_round1_l"];
      const vision_r1_l = variableMap["vis_round1_l"];
      const collab_r1_l = variableMap["col_round1_l"];
      const strategy_r1_l = variableMap["strat_round1_l"];

      let testingVarsMLeadership = [perform_r1_m, strategy_r1_m, vision_r1_m, collab_r1_m];
      let testingVarsLLeadership = [perform_r1_l, strategy_r1_l, vision_r1_l, collab_r1_l];


      let testingVarsM = [heart_r1_m, soul_round1_m, mind_round1_m, strength_round1_m];
      let testingVarsL = [heart_r1_l, soul_round1_l, mind_round1_l, strength_round1_l];

      setTieBreakers({
        most: testingVarsM,
        least: testingVarsL
      })
      setTieBreakersLeaderShip({
        most: testingVarsMLeadership,
        least: testingVarsLLeadership
      })


      console.log("variableMap", variableMap)

      setVariableMapArray(variableMap)

      setClientId(data?.sections[0]?.clientId)
      return data;
    } catch (error) {
      console.error("Failed to fetch results data:", error.message);
      throw error;
    }
  };

  // console.log("searchParams.get('member')", searchParams.get("member"));

  useEffect(() => {
    // to hide Next button when user has just answered the question (500ms delay) and 
    // to show it again when user clicks on Prev button

    let timeoutId = null;


    const hideNextButton = () => {
      if (pageId == '953' || pageId == '954') {
        const ans = questions?.[activeStep]?.answers?.find((el) => el?.value == questions?.[activeStep]?.answer)
        const isValidAns = findIsValidAns(ans)


        if (!questions?.[activeStep]?.answer) return false;

        return isValidAns;
      }
      else if ((questions?.[activeStep]?.answer >= 0)) {
        return true;
      }
    }

    let conditionToShowNextBtn = (
      (questions?.[activeStep]?.answerType !== "slider" &&
        questions?.[activeStep]?.answerType !== "multiple_choice" &&
        questions?.[activeStep]?.answerType !== "month_year") ||
      hideNextButton()
    );




    let hidNextBtn = false;
    if (pageId == "866" || pageId == "947") {
      const currentQuestion = questions[activeStep]
      if (currentQuestion?.variable?.includes("pass2")) {
        if (currentQuestion?.answer == questions[activeStep - 1]?.answer) {
          hidNextBtn = true;
        }
      }
    }

    if (conditionToShowNextBtn && !prevBtnClicked && !hidNextBtn) {
      timeoutId = setTimeout(() => {
        setShowNextBtn(true);
      }, 500);
    }

    if (conditionToShowNextBtn && prevBtnClicked && !hidNextBtn) {
      setPrevBtnClicked(false);
      setShowNextBtn(true);
    }

    if (!conditionToShowNextBtn || hidNextBtn) {
      setShowNextBtn(false);
    }

    return () => {
      clearTimeout(timeoutId);
    }
  }, [prevBtnClicked, activeStep, questions]);

  useEffect(() => {
    if (localStorage.getItem("backFromAddQPage") === "true" && questions?.length) {
      // console.log("activeStep", activeStep); 
      // setActiveStep(questions?.length - 1);
      localStorage.removeItem("backFromAddQPage");
    }
  }, [questions, pageId]);

  console.log("hasVisited", hasVisited)

  useEffect(() => {
    assessCtx?.setAssessmentId(id)
  }, [id])

  useEffect(() => {
    const isStarter = twoWaytieBreakersPageIdArray?.includes(parseInt(pageId)) || threeWaytieBreakersPageIdArray?.includes(parseInt(pageId)) || pageId == 866;
    const isStarterR2 = twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(pageId)) || pageId == 953;
    const isLeaders = twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(pageId)) || threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(pageId)) || pageId == 947;
    const isLeadersR2 = twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(pageId)) || pageId == 954;
    const isMindSet = pageId == 948;

    // console.log("pageId-currentPageIdObj-testingVarsM2-testingVarsL2-isStarterR2", testingVarsM2, testingVarsL2, isStarterR2)
    if (isStarter) {
      assessCtx?.updateAllQuestions(pageId, questions, isMost, testingVarsM, testingVarsL)
    }
    else if (isStarterR2) {
      assessCtx?.updateAllQuestions(pageId, questions, isMost, testingVarsM2, testingVarsL2)
    }
    else if (isLeaders) {
      assessCtx?.updateAllQuestions(pageId, questions, isMost, testingVarsMLeadership, testingVarsLLeadership)
    }
    else if (isLeadersR2) {
      assessCtx?.updateAllQuestions(pageId, questions, isMost, testingVarsMLeadershipRound2, testingVarsLLeadershipRound2)
    }
    else if (isMindSet) {
      assessCtx?.updateAllQuestions(pageId, questions, isMost, testingVarsMLeadershipRound2, testingVarsLLeadershipRound2)
    }

  }, [assessCtx?.questions, questions, activeStep])

  // change activestep for most least hide 
  useEffect(() => {
    const allLeastQuestions = questions?.filter((el) => el.variable?.includes("_l"));
    const first_least_question = allLeastQuestions.at(0);

    const allMostQuestions = questions?.filter((el) => !el.variable?.includes("_l"));
    const first_most_question = allMostQuestions.at(0);

    let currentQuestionsSet = assessCtx?.allQuestions?.[assessCtx?.allQuestions?.length - 1]?.data

    console.log("currentQuestion-activeQuestion", currentQuestionsSet?.[activeStep], questions?.[activeStep]);

    if (currentQuestionsSet?.[activeStep]?.answer > 0 && !questions?.[activeStep]?.answer > 0 && currentQuestionsSet?.[activeStep]?.pageId == pageId?.toString()) {
      // setQuestions(currentQuestionsSet)
    }



    const isThreeWayTieBreakerPage = threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(pageId)) || threeWaytieBreakersPageIdArray?.includes(parseInt(pageId));

    const isTwoWayTieBreakerPage = twoWaytieBreakersPageIdArray?.includes(parseInt(pageId)) ||
      twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(pageId)) ||
      twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(pageId)) || twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(pageId))



    // console.log("isMost-isTwoWayTieBreakerPage",isMost,isTwoWayTieBreakerPage)

    if (!isMost && (isThreeWayTieBreakerPage || isTwoWayTieBreakerPage)) {
      setActiveStep(1);
    }
    else if (isMost && (isThreeWayTieBreakerPage || isTwoWayTieBreakerPage)) {
      setActiveStep(0);
    }

  }, [activeStep, questions, pageId, isMost, assessCtx?.allQuestions]);

  async function changeContentAsPerRole(role, questionsArr, sectionsArr) {
    const allQuestions = questionsArr?.sort((a, b) => a.orderNo - b.orderNo);
    const isThreeWayTieBreakerPage = threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(pageId)) || threeWaytieBreakersPageIdArray?.includes(parseInt(pageId));
    const isTwoWayTieBreakerPage = twoWaytieBreakersPageIdArray?.includes(parseInt(pageId)) || twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(pageId)) || twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(pageId)) || twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(pageId))

    const savedProgressFunction = async () => {
      setIsLoading(true)
      const fetchedProg = await fetchAssessmentProgress(id)

      console.log("fetchedProg-backButtonClicked", fetchedProg, backButtonClicked)

      if (fetchedProg?.data && !backButtonClicked) {
        assessCtx?.setAllQuestions(fetchedProg?.data)
        localStorage.setItem(`allQuestions-${id}`, JSON.stringify(fetchedProg?.data))
        const currentPageIdQs = fetchedProg?.data?.find((el) => el?.pageId == pageId)
        setIsMost(currentPageIdQs?.isMost)

        const allPageIdArray = fetchedProg?.data?.map((el) => { return el?.pageId })

        if (allPageIdArray?.length > 0 && !allPageIdArray?.includes(pageId)) {
          const lastPageId = allPageIdArray[allPageIdArray?.length - 1]
          const isStarterTb = twoWaytieBreakersPageIdArray?.includes(parseInt(lastPageId)) || threeWaytieBreakersPageIdArray?.includes(parseInt(lastPageId))
          const isLeaderTb = twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(lastPageId)) || threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(lastPageId))
          const isStarterTbR2 = twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(lastPageId))
          const isLeaderTbR2 = twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(lastPageId))

          if (isStarterTb) {
            navigate(`/assessment/${id}/${lastPageId}/?next_page=${953}`)
          }
          else if (isLeaderTb) {
            navigate(`/assessment/${id}/${lastPageId}/?next_page=${954}`)
          }
          else if (isStarterTbR2) {
            navigate(`/assessment/${id}/${lastPageId}/?next_page=${947}`)
          }
          else if (isLeaderTbR2) {
            navigate(`/assessment/${id}/${lastPageId}/?next_page=${948}`)
          }
          else {
            navigate("/assessment/" + id + "/" + lastPageId);
          }


        }

        if (currentPageIdQs?.data?.length > 0 && !backButtonClicked) {
          let currentQIndex = currentPageIdQs?.data?.findIndex((el) => !el?.answer > 0)

          setQuestions(currentPageIdQs?.data)
          if (currentPageIdQs?.data?.[0]?.answer > 0 && !isTwoWayTieBreakerPage && !isThreeWayTieBreakerPage) {

            if (!currentPageIdQs?.data?.[0]?.answer > 0) { // if not a even single question is answered
              setActiveStep(0)
            }
            else if (currentQIndex >= 0) {
              setActiveStep(currentQIndex)
            }
            else {
              if (pageId == "953" || pageId == "954") {
                setActiveStep(currentPageIdQs?.data?.length - 2)
              }
              else if (pageId == "866" || pageId == "947") {
                setActiveStep(currentPageIdQs?.data?.length - 1)
              }
            }
          }
          else {
            if (!isMost && (isThreeWayTieBreakerPage || isTwoWayTieBreakerPage)) {
              setActiveStep(1);
            }
            else if (isMost && (isThreeWayTieBreakerPage || isTwoWayTieBreakerPage)) {
              setActiveStep(0);
            }
            else {
              setActiveStep(currentPageIdQs?.data?.length - 1)
            }
          }

        }
        else {
          setQuestions(allQuestions);
        }
      }
      else {
        setQuestions(allQuestions);
      }

      setHasVisited(hasVisited + 1)
    }

    // hasVisited == 0 && savedProgressFunction() // saved progress functionality
    // hasVisited != 0 && setQuestions(allQuestions); // saved progress functionality
    setQuestions(allQuestions);
    setSections(sectionsArr);
    setQuestionCount(allQuestions?.length);
    setIsLoading(false)
    setBackButtonClicked(false)
  }

  function getQuestions() {
    setIsLoading(true)

    let clientId = process.env.REACT_APP_CLIENT_ID;
    fetch(process.env.REACT_APP_API_URI + '/v3/user/assessment/' + id + '/pages/' + pageId, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' }
    }).then(response => {
      return response.json();
    }).then(data => {
      if (data.status == "success") {
        // console.log(data);
        let questions = data.data?.questions;
        if (retrieveStoredAnswers()) {
          let answeredQuestions = [];
          let storedQuestions = retrieveStoredAnswers();
          questions?.forEach(q => {
            let question = storedQuestions.find(obj => obj.id == q.id);
            if (question) {
              q.answerTxt = question.answerTxt;
              q.answer = question.answer;
              q.answers = question.answers;
            }
          })
        }
        // setSections(data.sections);
        // setQuestions(data.questions);
        // setQuestionCount(data.questions?.length);
        // assessCtx.addQuestions(questions);
        // if((data.hasAdditional === "yes") || (data.hasAdditional === true)) setHasAdditional(true);

        // go to first unanswered question 
        let goingForward = localStorage.getItem("goingForward") === "true" ? true : false;

        const jumpToUnansweredQuestion = async () => {
          let sortedQuestions = [...data?.data.questions];
          let flag = true;
          sortedQuestions.reverse();
          // console.log("sortedQuestions",sortedQuestions)

          for (let i = 0; i < sortedQuestions?.length; i++) {
            if (sortedQuestions[i]?.answer > 0) {
              if (pageId == "953" || pageId == "954") {
                if (backFromTieBreaker) {
                  setActiveStep(((sortedQuestions?.length - i) - 2));
                }
                else {
                  setActiveStep(0);
                }
              }
              else {
                if (backFromTieBreaker) {
                  setActiveStep(((sortedQuestions?.length - i) - 1));
                }
                else {
                  setActiveStep(0);
                }
              }
              // console.log("i-sortedQuestions[i]",i,sortedQuestions[i])
              flag = false;
            }

            if (!flag) break;
          }

          if (flag && !sortedQuestions?.[0]?.answer > 0) {
            setActiveStep(0);
          }
          else if (flag) {
            setActiveStep(sortedQuestions?.length - 1);
          }

        }

        if (goingForward) {
          setActiveStep(0);
          localStorage.removeItem("goingForward");
        }
        else jumpToUnansweredQuestion();
        changeContentAsPerRole(selectedRole, data?.data?.questions, data?.data?.sections);
        setFetchedQuestions(data?.data?.questions);
      } else {
        // setOpenSnackbar(true);
      }
    }).catch((err) => console.error("Error while fetching questions...", err));
    // }
  }

  const mostExists = (arr) => {

    if (arr.every(num => num === 0)) {
      return true;
    }

    const max = Math.max(...arr);

    const countMax = arr.filter(num => num === max).length;

    return !(countMax === 2 || countMax === 3);
  }

  const leastExists = (arr) => {

    if (arr.every(num => num === 0)) {
      return true;
    }

    const max = Math.max(...arr);

    const countMax = arr.filter(num => num === max).length;

    return !(countMax === 2 || countMax === 3);
  }

  const whichEdgeCase = (testingVarsL, testingVarsM) => {

    const mostMaxValueAndIndex = testingVarsM?.reduce((acc, curr, index) => {
      return curr > acc.value ? { value: curr, index } : acc
    }, { value: 0, index: -1 })

    const leastMaxValue = testingVarsL?.reduce((acc, curr, index) => {
      return curr > acc.value ? { value: curr, index } : acc
    }, { value: 0, index: -1 })

    const maxVal = Math.max(...testingVarsL);
    const leastCount = testingVarsL.filter(num => num === maxVal).length;

    console.log("mostMaxValueAndIndex", mostMaxValueAndIndex)
    console.log("mostMaxValueAndIndex leastCount", leastCount)
    console.log("mostMaxValueAndIndex testingVarsL", testingVarsL)
    console.log("mostMaxValueAndIndex testingVarsM", testingVarsM)
    console.log("mostMaxValueAndIndex leastMaxValue", testingVarsL[mostMaxValueAndIndex?.index] == leastMaxValue?.value)
    console.log("mostMaxValueAndIndex testingVarsL testingVarsM", testingVarsL, testingVarsM)


    if (leastCount == 3 && testingVarsL[mostMaxValueAndIndex?.index] == leastMaxValue?.value) { // edge case #1 : [12,12,12,4] [1,3,3,3]      
      return "edge_case_1";
    }
    else if (leastCount == 2 && testingVarsL[mostMaxValueAndIndex?.index] == leastMaxValue?.value) { // edge case #1 : [12,12,12,4] [1,3,3,3]  
      return "edge_case_2";
    }
    else if (testingVarsL[mostMaxValueAndIndex?.index] == leastMaxValue?.value) { // edge case case #3: [12,12,12,4] [6,2,2,0]
      return "edge_case_3";
    }

    return "no_edge_case";

  }

  // starter least tie breakers
  const getLeastRound1StarterTieBreakers = (testingVarsL, testingVarsM, strength_round1_l, mind_round1_l, soul_round1_l, heart_r1_l, next_page_id, starterEdgeCaseCheck, starterEdgeCase1Check) => {

    const edge_case = whichEdgeCase(testingVarsL, testingVarsM)

    console.log("edge_case", edge_case)

    if (edge_case == "edge_case_1") {
      const mostMaxValueAndIndex = testingVarsM?.reduce((acc, curr, index) => {
        return curr > acc.value ? { value: curr, index } : acc
      }, { value: 0, index: -1 })

      let updatedPayload = testingVarsL;
      updatedPayload[mostMaxValueAndIndex?.index] = testingVarsL[mostMaxValueAndIndex?.index] - 1;

      // console.log("updatedPayload",updatedPayload)
      resetScores(testingVarsM, updatedPayload, 866, next_page_id, false, true);
    }
    else if (edge_case == "edge_case_2") {
      const mostMaxValueAndIndex = testingVarsM?.reduce((acc, curr, index) => {
        return curr > acc.value ? { value: curr, index } : acc
      }, { value: 0, index: -1 })

      let updatedPayload = testingVarsL;
      updatedPayload[mostMaxValueAndIndex?.index] = testingVarsL[mostMaxValueAndIndex?.index] - 1;

      // console.log("updatedPayload",updatedPayload)
      resetScores(testingVarsM, updatedPayload, 866, next_page_id, false, true);
    }

    if (leastExists(testingVarsL)) {
      if (testingVarsL.every(num => num === 0)) {
        setActiveStep(0)
        setIsLoading(false)
      }
    }
    else if (edge_case == "no_edge_case") {
      if (strength_round1_l === mind_round1_l && soul_round1_l === mind_round1_l) {
        fetchTieBreakerQuestions(955, next_page_id);
        setIsMost(false)
      }
      else if (strength_round1_l === mind_round1_l && heart_r1_l === mind_round1_l) {
        fetchTieBreakerQuestions(956, next_page_id);
        setIsMost(false)
      }
      else if (strength_round1_l === soul_round1_l && heart_r1_l === soul_round1_l) {
        fetchTieBreakerQuestions(957, next_page_id);
        setIsMost(false)
      }
      else if (mind_round1_l === soul_round1_l && heart_r1_l === soul_round1_l) {
        fetchTieBreakerQuestions(958, next_page_id);
        setIsMost(false)
      }
      else if (strength_round1_l === mind_round1_l && eliminate2wayEdgeCases(testingVarsL, strength_round1_l, mind_round1_l)) {
        fetchTieBreakerQuestions(959, next_page_id);
        setIsMost(false)
      }
      else if (strength_round1_l === heart_r1_l && eliminate2wayEdgeCases(testingVarsL, strength_round1_l, heart_r1_l)) {
        fetchTieBreakerQuestions(966, next_page_id);
        setIsMost(false)
      }
      else if (strength_round1_l === soul_round1_l && eliminate2wayEdgeCases(testingVarsL, strength_round1_l, soul_round1_l)) {
        fetchTieBreakerQuestions(967, next_page_id);
        setIsMost(false)
      }
      else if (mind_round1_l === heart_r1_l && eliminate2wayEdgeCases(testingVarsL, mind_round1_l, heart_r1_l)) {
        fetchTieBreakerQuestions(968, next_page_id);
        setIsMost(false)
      }
      else if (mind_round1_l === soul_round1_l && eliminate2wayEdgeCases(testingVarsL, mind_round1_l, soul_round1_l)) {
        fetchTieBreakerQuestions(969, next_page_id);
        setIsMost(false)
      }
      else if (heart_r1_l === soul_round1_l && eliminate2wayEdgeCases(testingVarsL, heart_r1_l, soul_round1_l)) {
        fetchTieBreakerQuestions(970, next_page_id);
        setIsMost(false)
      }
    }

    if (mostExists(testingVarsM) && leastExists(testingVarsL)) {
      navigate("/assessment/" + id + "/953");
    }
  }

  // starter most tie breakers
  const getMostRound1StarterTieBreakers = (testingVarsM, strength_round1_m, mind_round1_m, soul_round1_m, heart_r1_m, id, searchParams, next_page_id) => {
    if (mostExists(testingVarsM)) {
      if (testingVarsM.every(num => num === 0)) {
        // console.log('zero vals')
      }
    }
    else {
      if (strength_round1_m === mind_round1_m && eliminate2wayEdgeCases(testingVarsM, strength_round1_m, mind_round1_m)) {
        fetchTieBreakerQuestions(959, next_page_id);
        setIsMost(true)
      }
      else if (strength_round1_m === heart_r1_m && eliminate2wayEdgeCases(testingVarsM, strength_round1_m, heart_r1_m)) {
        fetchTieBreakerQuestions(966, next_page_id);
        setIsMost(true)
      }
      else if (strength_round1_m === soul_round1_m && eliminate2wayEdgeCases(testingVarsM, strength_round1_m, soul_round1_m)) {
        fetchTieBreakerQuestions(967, next_page_id);
        setIsMost(true)
      }
      else if (mind_round1_m === heart_r1_m && eliminate2wayEdgeCases(testingVarsM, mind_round1_m, heart_r1_m)) {
        fetchTieBreakerQuestions(968, next_page_id);
        setIsMost(true)
      }
      else if (mind_round1_m === soul_round1_m && eliminate2wayEdgeCases(testingVarsM, mind_round1_m, soul_round1_m)) {
        fetchTieBreakerQuestions(969, next_page_id);
        setIsMost(true)
      }
      else if (heart_r1_m === soul_round1_m && eliminate2wayEdgeCases(testingVarsM, heart_r1_m, soul_round1_m)) {
        fetchTieBreakerQuestions(970, next_page_id);
        setIsMost(true)
      }
    }
  }

  // starter round 2 least tie breakers
  const getLeastRound2StarterTieBreakers = (testingVarsL2, strength_round2_l, mind_round2_l, soul_round2_l, heart_r2_l, id, searchParams, next_page_id) => {
    if (leastExists(testingVarsL2)) {
      if (testingVarsL2.every(num => num === 0)) {
        setActiveStep(0)
        setIsLoading(false)
      }
    }
    else {
      if (strength_round2_l === mind_round2_l && soul_round2_l === mind_round2_l) {
        fetchTieBreakerQuestions(979, next_page_id);
        setIsMost(false)
      }
      else if (strength_round2_l === mind_round2_l && heart_r2_l === mind_round2_l) {
        fetchTieBreakerQuestions(980, next_page_id);
        setIsMost(false)
      }
      else if (strength_round2_l === soul_round2_l && heart_r2_l === soul_round2_l) {
        fetchTieBreakerQuestions(981, next_page_id);
        setIsMost(false)
      }
      else if (mind_round2_l === soul_round2_l && heart_r2_l === soul_round2_l) {
        fetchTieBreakerQuestions(982, next_page_id);
        setIsMost(false)
      }
      else if (strength_round2_l === mind_round2_l && eliminate2wayEdgeCases(testingVarsL2, strength_round2_l, mind_round2_l)) {
        fetchTieBreakerQuestions(985, next_page_id);
        setIsMost(false)
      }
      else if (strength_round2_l === heart_r2_l && eliminate2wayEdgeCases(testingVarsL2, strength_round2_l, heart_r2_l)) {
        fetchTieBreakerQuestions(986, next_page_id);
        setIsMost(false)
      }
      else if (strength_round2_l === soul_round2_l && eliminate2wayEdgeCases(testingVarsL2, strength_round2_l, soul_round2_l)) {
        fetchTieBreakerQuestions(987, next_page_id);
        setIsMost(false)
      }
      else if (mind_round2_l === heart_r2_l && eliminate2wayEdgeCases(testingVarsL2, mind_round2_l, heart_r2_l)) {
        fetchTieBreakerQuestions(989, next_page_id);
        setIsMost(false)
      }
      else if (mind_round2_l === soul_round2_l && eliminate2wayEdgeCases(testingVarsL2, mind_round2_l, soul_round2_l)) {
        fetchTieBreakerQuestions(990, next_page_id);
        setIsMost(false)
      }
      else if (heart_r2_l === soul_round2_l && eliminate2wayEdgeCases(testingVarsL2, heart_r2_l, soul_round2_l)) {
        fetchTieBreakerQuestions(978, next_page_id);
        setIsMost(false)
      }
    }

    if (mostExists(testingVarsM2) && leastExists(testingVarsL2)) {
      navigate("/assessment/" + id + "/947" + "/?" + removeNextSearchParam(searchParams), { replace: true });
    }
  }

  const getMostRound1LeaderTieBreakers = (testingVarsM, strategy_r1_m, vision_r1_m, collab_r1_m, perform_r1_m, id, searchParams, next_page_id) => {
    if (mostExists(testingVarsM)) {
      if (testingVarsM.every(num => num === 0)) {
        // console.log("Zero values for most");
      }
    }
    else {
      // Handle tie-breaking logic for "most"
      // if (strategy_r1_m === vision_r1_m && strategy_r1_m === perform_r1_m) {
      //   fetchTieBreakerQuestions(960, next_page_id);
      //   setIsMost(true);
      // } else if (strategy_r1_m === collab_r1_m && strategy_r1_m === perform_r1_m) {
      //   fetchTieBreakerQuestions(961, next_page_id);
      //   setIsMost(true);
      // } else if (vision_r1_m === perform_r1_m && vision_r1_m === collab_r1_m) {
      //   fetchTieBreakerQuestions(962, next_page_id);
      //   setIsMost(true);
      // } else if (strategy_r1_m === collab_r1_m && strategy_r1_m === vision_r1_m) {
      //   fetchTieBreakerQuestions(963, next_page_id);
      //   setIsMost(true);
      // } else
      if (strategy_r1_m === perform_r1_m && eliminate2wayEdgeCases(testingVarsM, strategy_r1_m, perform_r1_m)) {
        fetchTieBreakerQuestions(964, next_page_id);
        setIsMost(true);
      } else if (vision_r1_m === perform_r1_m && eliminate2wayEdgeCases(testingVarsM, vision_r1_m, perform_r1_m)) {
        fetchTieBreakerQuestions(971, next_page_id);
        setIsMost(true);
      } else if (perform_r1_m === collab_r1_m && eliminate2wayEdgeCases(testingVarsM, perform_r1_m, collab_r1_m)) {
        fetchTieBreakerQuestions(972, next_page_id);
        setIsMost(true);
      } else if (vision_r1_m === strategy_r1_m && eliminate2wayEdgeCases(testingVarsM, vision_r1_m, strategy_r1_m)) {
        fetchTieBreakerQuestions(973, next_page_id);
        setIsMost(true);
      } else if (strategy_r1_m === collab_r1_m && eliminate2wayEdgeCases(testingVarsM, strategy_r1_m, collab_r1_m)) {
        fetchTieBreakerQuestions(974, next_page_id);
        setIsMost(true);
      } else if (vision_r1_m === collab_r1_m && eliminate2wayEdgeCases(testingVarsM, vision_r1_m, collab_r1_m)) {
        fetchTieBreakerQuestions(975, next_page_id);
        setIsMost(true);
      }
    }
  }

  // leadership least tie breakers
  const getLeastRound1LeadersTieBreakers = (testingVarsL, testingVarsM, perform_r1_l, vision_r1_l, collab_r1_l, strategy_r1_l, id, searchParams, next_page_id, leaderEdgeCase1Check) => {

    const edge_case = whichEdgeCase(testingVarsL, testingVarsM)

    console.log("updatedPayload", edge_case)

    if (edge_case == "edge_case_1") {
      const mostMaxValueAndIndex = testingVarsM?.reduce((acc, curr, index) => {
        return curr > acc.value ? { value: curr, index } : acc
      }, { value: 0, index: -1 })

      let updatedPayload = testingVarsL;
      updatedPayload[mostMaxValueAndIndex?.index] = testingVarsL[mostMaxValueAndIndex?.index] - 1;

      console.log("updatedPayload", updatedPayload, '-', testingVarsM)
      resetScores(testingVarsM, updatedPayload, 947, next_page_id, false, true);
    }
    else if (edge_case == "edge_case_2") {
      const mostMaxValueAndIndex = testingVarsM?.reduce((acc, curr, index) => {
        return curr > acc.value ? { value: curr, index } : acc
      }, { value: 0, index: -1 })

      let updatedPayload = testingVarsL;
      updatedPayload[mostMaxValueAndIndex?.index] = testingVarsL[mostMaxValueAndIndex?.index] - 1;

      // console.log("updatedPayload",updatedPayload)
      resetScores(testingVarsM, updatedPayload, 947, next_page_id, false, true);
    }

    if (leastExists(testingVarsL)) {
      if (testingVarsL.every(num => num === 0)) {
        setActiveStep(0)
        setIsLoading(false)

      }
    }
    else if (edge_case == "no_edge_case") {
      if (strategy_r1_l === vision_r1_l && strategy_r1_l === perform_r1_l) {
        fetchTieBreakerQuestions(960, next_page_id);
        setIsMost(false)
      } else if (strategy_r1_l === collab_r1_l && strategy_r1_l === perform_r1_l) {
        fetchTieBreakerQuestions(961, next_page_id);
        setIsMost(false)
      } else if (vision_r1_l === perform_r1_l && vision_r1_l === collab_r1_l) {
        fetchTieBreakerQuestions(962, next_page_id);
        setIsMost(false)

      } else if (strategy_r1_l === collab_r1_l && strategy_r1_l === vision_r1_l) {
        fetchTieBreakerQuestions(963, next_page_id);
        setIsMost(false)

      } else if (strategy_r1_l === perform_r1_l && eliminate2wayEdgeCases(testingVarsL, strategy_r1_l, perform_r1_l)) {
        fetchTieBreakerQuestions(964, next_page_id);
        setIsMost(false)

      } else if (vision_r1_l === perform_r1_l && eliminate2wayEdgeCases(testingVarsL, vision_r1_l, perform_r1_l)) {
        fetchTieBreakerQuestions(971, next_page_id);
        setIsMost(false)

      } else if (perform_r1_l === collab_r1_l && eliminate2wayEdgeCases(testingVarsL, perform_r1_l, collab_r1_l)) {
        fetchTieBreakerQuestions(972, next_page_id);
        setIsMost(false)

      } else if (vision_r1_l === strategy_r1_l && eliminate2wayEdgeCases(testingVarsL, vision_r1_l, strategy_r1_l)) {
        fetchTieBreakerQuestions(973, next_page_id);
        setIsMost(false)

      } else if (strategy_r1_l === collab_r1_l && eliminate2wayEdgeCases(testingVarsL, strategy_r1_l, collab_r1_l)) {
        fetchTieBreakerQuestions(974, next_page_id);
        setIsMost(false)

      } else if (vision_r1_l === collab_r1_l && eliminate2wayEdgeCases(testingVarsL, vision_r1_l, collab_r1_l)) {
        fetchTieBreakerQuestions(975, next_page_id);
        setIsMost(false)

      }
    }

    if (mostExists(testingVarsM) && leastExists(testingVarsL)) {
      navigate("/assessment/" + id + "/95" + "/?" + removeNextSearchParam(searchParams), { replace: true });
    }
  };

  const getLeastRound2LeadershipTieBreakers = (testingVarsLLeadership, perform_r2_l, vision_r2_l, collab_r2_l, strategy_r2_l, id, searchParams, next_page_id) => {
    if (leastExists(testingVarsLLeadership)) {
      if (testingVarsLLeadership.every(num => num === 0)) {
        setActiveStep(0);
        setIsLoading(false);
      }
      else if (leastExists(testingVarsLLeadership)) {
        navigate("/assessment/" + id + "/948" + "/?" + removeNextSearchParam(searchParams), { replace: true });
      }
    }
    else {
      if (perform_r2_l === strategy_r2_l && eliminate2wayEdgeCases(testingVarsL, perform_r2_l, strategy_r2_l)) {
        fetchTieBreakerQuestions(996, next_page_id);
        setIsMost(false);
      } else if (perform_r2_l === vision_r2_l && eliminate2wayEdgeCases(testingVarsL, perform_r2_l, vision_r2_l)) {
        fetchTieBreakerQuestions(997, next_page_id);
        setIsMost(false);
      } else if (perform_r2_l === collab_r2_l && eliminate2wayEdgeCases(testingVarsL, perform_r2_l, collab_r2_l)) {
        fetchTieBreakerQuestions(998, next_page_id);
        setIsMost(false);
      } else if (strategy_r2_l === vision_r2_l && eliminate2wayEdgeCases(testingVarsL, strategy_r2_l, vision_r2_l)) {
        fetchTieBreakerQuestions(999, next_page_id);
        setIsMost(false);
      }
    }
  };

  // leadership most tie breakers
  const getMostRound2LeadershipTie = (testingVarsMLeadership, perform_r2_m, vision_r2_m, collab_r2_m, strategy_r2_m, id, searchParams, next_page_id) => {
    if (!mostExists(testingVarsMLeadership)) {
      if (perform_r2_m === strategy_r2_m && eliminate2wayEdgeCases(testingVarsMLeadership, perform_r2_m, strategy_r2_m)) {
        fetchTieBreakerQuestions(996, next_page_id);
        setIsMost(true);
      } else if (perform_r2_m === vision_r2_m && eliminate2wayEdgeCases(testingVarsMLeadership, perform_r2_m, vision_r2_m)) {
        fetchTieBreakerQuestions(997, next_page_id);
        setIsMost(true);
      } else if (perform_r2_m === collab_r2_m && eliminate2wayEdgeCases(testingVarsMLeadership, perform_r2_m, collab_r2_m)) {
        fetchTieBreakerQuestions(998, next_page_id);
        setIsMost(true);
      } else if (strategy_r2_m === vision_r2_m && eliminate2wayEdgeCases(testingVarsMLeadership, strategy_r2_m, vision_r2_m)) {
        fetchTieBreakerQuestions(999, next_page_id);
        setIsMost(true);
      }
    }
  }

  const eliminate2wayEdgeCases = (variablesArray, var1, var2) => {
    const max = Math.max(...variablesArray)
    const pageIdArray = assessCtx?.allQuestions?.map((el) => el?.pageId)

    if (var1 == max && max != 0) { // [ 12, 12, 8, 8 ] edge case 1
      return true;
    }

    return false;
  }


  // leaders least 




  // useEffect(() => {
  //   setQuestions(apiData);
  // }, [apiData])

  // console.log("apiData", apiData);

  const currentSectionName = sections?.find(section => section.id === questions?.[activeStep]?.sectionId)?.section;
  const currentQuestionTitle = questionTitles?.find(title => title.id === questions?.[activeStep]?.orderNo)?.text;

  // console.log("hasAdditional", hasAdditional);
  console.log("resultsData", resultData)

  function completeAssessment(load, next_page_id) {
    // load !== "no-load" && setIsLoading(true);

    let clientId = process.env.REACT_APP_CLIENT_ID;

    let isReview = false;
    if (id != null) {
      isReview = true;
    }


    const payloadQuestions = questions?.filter((el) => el?.pageId == pageId)
    // console.log("payloadQuestions", payloadQuestions)
    const jsonBody = { pageId: parseInt(pageId), questions: payloadQuestions, isReview: isReview }

    fetch(process.env.REACT_APP_API_URI + '/v3/user/assessment/' + id, {
      method: 'PUT', mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(jsonBody)
    }).then(response => {
      return response.json();
    }).then(async (data) => {
      if (data.status === "success") {

        const addQuestionsPageId = 805;
        localStorage.removeItem("assessmentAnswers");
        // const assessmentName = localStorage.getItem("assessmentName");
        // navigate(`/assessment-additional/${id}/${addQuestionsPageId}?${searchParams}`, { replace: true });
        // navigate(`/${assessmentName}/outro/${id}/?${searchParams}`, { replace: true });
        if (load == "no-load") {
          fetchResults(parseInt(pageId), next_page_id, true)
        }
        if (pageId === "948") {
          markAssessmentAsCompleted();
        }
        // console.log("data", data);
      } else {

        // setIsSaving(false);
        // setOpenSnackbar(true);
      }
    }).catch((err) => {
      console.error("Failed to submit answers...", err);
      setIsLoading(false);
    });


    // console.log("questions", questions);
    // fetch(process.env.REACT_APP_API_URI + '/v3/questions/' + questionsCtx.currentPage, {
    //   method: 'POST', mode: 'cors',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify({ clientId, questions, isReview, id })
    // }).then(response => {
    //   return response.json();
    // }).then(data => {
    //   if (data.status == "success") {
    //     if (hasAdditional) {
    //       if (data.member) {
    //         if (searchParams.get("member") === data.memberId) {
    //           navigate("/assessment-additional/" + data.id + "?" + searchParams, { replace: true });
    //         } else navigate("/assessment-additional/" + data.id + "?member=" + data.memberId, { replace: true });
    //       } else navigate("/assessment-additional/" + data.id, { replace: true });
    //     } else {
    //       if (searchParams.get("user") === data.memberId) {
    //         navigate("/details/" + data.id + "?member=" + data.memberId, { replace: true });
    //       } else {
    //         // navigate("/pre-additional-info/" + data.id, { replace: true });
    //         navigate("/details/" + data.id + "?" + searchParams, { replace: true });
    //       }
    //     }
    //   } else {
    //     // setOpenSnackbar(true);
    //   }
    // });

  }

  const fetchResults = async (pageId, next_page_id, isTieBreaker) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/user/assessment/${id}/results`, {
        method: "GET",
        mode: "cors",
        headers: { 'Content-Type': 'application/json' }
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setResultData(data)
      const variableMap = data?.variables?.reduce((acc, el) => {
        acc[el.variable] = el.score;
        return acc;
      }, {});

      setVariableMapArray(variableMap)

      const next_page_id_param = searchParams.get("next_page")


      const heart_r1_m = variableMap["heart_round1_m"];
      const soul_round1_m = variableMap["soul_round1_m"];
      const mind_round1_m = variableMap["mind_round1_m"];
      const strength_round1_m = variableMap["str_round1_m"];

      const heart_r1_l = variableMap["heart_round1_l"];
      const soul_round1_l = variableMap["soul_round1_l"];
      const mind_round1_l = variableMap["mind_round1_l"];
      const strength_round1_l = variableMap["str_round1_l"];
      let testingVarsM = [heart_r1_m, soul_round1_m, mind_round1_m, strength_round1_m];
      let testingVarsL = [heart_r1_l, soul_round1_l, mind_round1_l, strength_round1_l];

      let testingVarsMLs = assessCtx?.allQuestions[assessCtx?.allQuestions?.length - 1]?.mostScores
      let testingVarsLLs = assessCtx?.allQuestions[assessCtx?.allQuestions?.length - 1]?.leastScores

      let starterEdgeCaseCheck = false; // edge case #2 [40 0 0 0] [ 10 0 0 0]
      let starterEdgeCase1Check = findIsEdgeCase1(testingVarsMLs, testingVarsLLs); // edge case #1 [20 0 0 20] [ 5 0 0 5]

      if (mostExists(testingVarsM) && leastExists(testingVarsL)) {
        let maxM = Math.max(...testingVarsM);
        let maxL = Math.max(...testingVarsL);

        let maxIndexM = testingVarsM.indexOf(maxM);
        let maxIndexL = testingVarsL.indexOf(maxL);

        if (maxIndexM === maxIndexL && maxM > 0 && maxL > 0) {
          starterEdgeCaseCheck = true;
        }
      }
      else {
        starterEdgeCaseCheck = false;
      }

      starterEdgeCaseCheck && console.log("Tie breaker After getting edge case 2")
      starterEdgeCase1Check && console.log("Tie breaker After getting edge case 1")
      const heart_r2 = variableMap["heart_round2_m"];
      const soul_r2 = variableMap["soul_round2_m"];
      const mind_r2 = variableMap["mind_round2_m"];
      const strength_r2 = variableMap["str_round2_m"];

      const heart_r2_l = variableMap["heart_round2_l"];
      const soul_round2_l = variableMap["soul_round2_l"];
      const mind_round2_l = variableMap["mind_round2_l"];
      const strength_round2_l = variableMap["str_round2_l"];

      let testingVarsM2 = [heart_r2, soul_r2, mind_r2, strength_r2];
      let testingVarsL2 = [heart_r2_l, soul_round2_l, mind_round2_l, strength_round2_l];

      setStarterMostScores(testingVarsM)
      console.log("Tie breakers H - S - M - ST round1")
      console.log("Tie breakers MOST vars - ", testingVarsM)
      console.log("Tie breakers LEAST vars - ", testingVarsL)

      console.log("Tie breakers H - S - M - ST round2")
      console.log("Tie breakers MOST vars - ", testingVarsM2)
      console.log("Tie breakers LEAST vars - ", testingVarsL2)

      const perform_r1_m = variableMap["per_round1_m"];
      const vision_r1_m = variableMap["vis_round1_m"];
      const collab_r1_m = variableMap["col_round1_m"];
      const strategy_r1_m = variableMap["strat_round1_m"];

      const perform_r1_l = variableMap["per_round1_l"];
      const vision_r1_l = variableMap["vis_round1_l"];
      const collab_r1_l = variableMap["col_round1_l"];
      const strategy_r1_l = variableMap["strat_round1_l"];

      let testingVarsMLeadership = [perform_r1_m, strategy_r1_m, vision_r1_m, collab_r1_m];
      let testingVarsLLeadership = [perform_r1_l, strategy_r1_l, vision_r1_l, collab_r1_l];

      setTieBreakers({
        most: testingVarsM,
        least: testingVarsL
      })
      setTieBreakersLeaderShip({
        most: testingVarsMLeadership,
        least: testingVarsLLeadership
      })

      let testingVarsMLeadershipLs = assessCtx?.allQuestions[assessCtx?.allQuestions?.length - 1]?.mostScores
      let testingVarsLLeadershipLs = assessCtx?.allQuestions[assessCtx?.allQuestions?.length - 1]?.leastScores

      let leaderEdgeCaseCheck = false;
      let leaderEdgeCase1Check = findIsEdgeCase1(testingVarsMLeadershipLs, testingVarsLLeadershipLs); // edge case #1 [20 0 0 20] [ 5 0 0 5]

      if (mostExists(testingVarsMLeadership) && leastExists(testingVarsLLeadership)) {
        let maxM = Math.max(...testingVarsMLeadership);
        let maxL = Math.max(...testingVarsLLeadership);

        let maxIndexM = testingVarsMLeadership.indexOf(maxM);
        let maxIndexL = testingVarsLLeadership.indexOf(maxL);

        if (maxIndexM === maxIndexL && maxM > 0 && maxL > 0) {
          leaderEdgeCaseCheck = true;
        }
      }
      else {
        leaderEdgeCaseCheck = false;
      }

      const perform_r2_m = variableMap["per_round2_m"];
      const vision_r2_m = variableMap["vis_round2_m"];
      const collab_r2_m = variableMap["col_round2_m"];
      const strategy_r2_m = variableMap["strat_round2_m"];

      // Least variables
      const perform_r2_l = variableMap["per_round2_l"];
      const vision_r2_l = variableMap["vis_round2_l"];
      const collab_r2_l = variableMap["col_round2_l"];
      const strategy_r2_l = variableMap["strat_round2_l"];

      const testingVarsMLeadershipRound2 = [perform_r2_m, strategy_r2_m, vision_r2_m, collab_r2_m];
      const testingVarsLLeadershipRound2 = [perform_r2_l, strategy_r2_l, vision_r2_l, collab_r2_l];

      setLeadershipMostScores(testingVarsMLeadership)
      leaderEdgeCaseCheck && console.log("Tie breaker After getting edge case 2")
      console.log("Tie breakers P - S - V - C round1")
      console.log("Tie breakers MOST vars - ", testingVarsMLeadership)
      console.log("Tie breakers LEAST vars - ", testingVarsLLeadership)

      console.log("Tie breakers P - S - V - C round2")
      console.log("Tie breakers MOST vars - ", testingVarsMLeadershipRound2)
      console.log("Tie breakers LEAST vars - ", testingVarsLLeadershipRound2)

      if (isTieBreaker) {
        // tie breakers for 866 ( round1 starter quandrant )

        if (pageId == 866) {

          const currentQuestion = questions[activeStep];

          // Most tie breakers
          if (mostExists(testingVarsM)) {
            if (testingVarsM.every(num => num === 0)) {
              setActiveStep(0)
              setIsLoading(false)
            }
          }
          else if (!mostExists(testingVarsM)) {
            if (strength_round1_m === mind_round1_m && soul_round1_m === mind_round1_m) {
              fetchTieBreakerQuestions(955, next_page_id);
              setIsMost(true)
            }
            else if (strength_round1_m === mind_round1_m && heart_r1_m === mind_round1_m) {
              fetchTieBreakerQuestions(956, next_page_id);
              setIsMost(true)
            }
            else if (strength_round1_m === soul_round1_m && heart_r1_m === soul_round1_m) {
              fetchTieBreakerQuestions(957, next_page_id);
              setIsMost(true)
            }
            else if (mind_round1_m === soul_round1_m && heart_r1_m === soul_round1_m) {
              fetchTieBreakerQuestions(958, next_page_id);
              setIsMost(true)
            }
            else if (strength_round1_m === mind_round1_m && eliminate2wayEdgeCases(testingVarsM, strength_round1_m, mind_round1_m)) {
              fetchTieBreakerQuestions(959, next_page_id);
              setIsMost(true)
            }
            else if (strength_round1_m === heart_r1_m && eliminate2wayEdgeCases(testingVarsM, strength_round1_m, heart_r1_m)) {
              fetchTieBreakerQuestions(966, next_page_id);
              setIsMost(true)
            }
            else if (strength_round1_m === soul_round1_m && eliminate2wayEdgeCases(testingVarsM, strength_round1_m, soul_round1_m)) {
              fetchTieBreakerQuestions(967, next_page_id);
              setIsMost(true)
            }
            else if (mind_round1_m === heart_r1_m && eliminate2wayEdgeCases(testingVarsM, mind_round1_m, heart_r1_m)) {
              fetchTieBreakerQuestions(968, next_page_id);
              setIsMost(true)
            }
            else if (mind_round1_m === soul_round1_m && eliminate2wayEdgeCases(testingVarsM, mind_round1_m, soul_round1_m)) {
              fetchTieBreakerQuestions(969, next_page_id);
              setIsMost(true)
            }
            else if (heart_r1_m === soul_round1_m && eliminate2wayEdgeCases(testingVarsM, heart_r1_m, soul_round1_m)) {
              fetchTieBreakerQuestions(970, next_page_id);
              setIsMost(true)
            }
          }

          if (mostExists(testingVarsM) && !leastExists(testingVarsL)) {
            getLeastRound1StarterTieBreakers(testingVarsL, testingVarsM, strength_round1_l, mind_round1_l, soul_round1_l, heart_r1_l, 953, starterEdgeCaseCheck, starterEdgeCase1Check);
          }

          const edge_case = whichEdgeCase(testingVarsL, testingVarsM)

          if (edge_case == "edge_case_3") {
            const mostMaxValueAndIndex = testingVarsM?.reduce((acc, curr, index) => {
              return curr > acc.value ? { value: curr, index } : acc
            }, { value: 0, index: -1 })



            const maxVal = Math.max(...testingVarsL);
            const secondMax = Math.max(...testingVarsL.filter(num => num !== maxVal));

            let updatedPayload = testingVarsL;
            updatedPayload[mostMaxValueAndIndex?.index] = secondMax - 1;

            console.log("updatedPayload", updatedPayload)
            console.log("updatedPayload secondMax", secondMax)
            console.log("updatedPayload testingVarsM", testingVarsM)
            resetScores(testingVarsM, updatedPayload, pageId, next_page_id, false, true);
          }

          console.log("edge_case", edge_case)

          if (mostExists(testingVarsM) && leastExists(testingVarsL) && edge_case === "no_edge_case") {
            navigate("/assessment/" + id + "/953");
          }
        }
        else if (threeWaytieBreakersPageIdArray?.includes(parseInt(pageId)) && next_page_id_param == "953") { // This block is triggering 2 way after 3 way tiebreaker and Least ties also
          // Most tie breakers
          // getMostRound1StarterTieBreakers(testingVarsM, strength_round1_m, mind_round1_m, soul_round1_m, heart_r1_m, id, searchParams, 953);

          const edge_case = whichEdgeCase(testingVarsL, testingVarsM)

          if (edge_case == "edge_case_3") {
            const mostMaxValueAndIndex = testingVarsM?.reduce((acc, curr, index) => {
              return curr > acc.value ? { value: curr, index } : acc
            }, { value: 0, index: -1 })



            const maxVal = Math.max(...testingVarsL);
            const secondMax = Math.max(...testingVarsL.filter(num => num !== maxVal));

            let updatedPayload = testingVarsL;
            updatedPayload[mostMaxValueAndIndex?.index] = secondMax - 1;

            console.log("updatedPayload", updatedPayload)
            console.log("updatedPayload secondMax", secondMax)
            console.log("updatedPayload testingVarsM", testingVarsM)
            resetScores(testingVarsM, updatedPayload, pageId, next_page_id, false, true);
          }

          console.log("edge_case", edge_case)

          // LEAST tie breakers
          if (leastExists(testingVarsL)) {
            if (testingVarsM.every(num => num === 0)) {
              if (testingVarsM.every(num => num === 0)) {
                // console.log('zero vals')
              }
            }
          }
          else if (mostExists(testingVarsM)) {
            getLeastRound1StarterTieBreakers(testingVarsL, testingVarsM, strength_round1_l, mind_round1_l, soul_round1_l, heart_r1_l, 953, starterEdgeCaseCheck, starterEdgeCase1Check);
          }

          if (mostExists(testingVarsM) && leastExists(testingVarsL)) {
            navigate("/assessment/" + id + "/953");
          }
        }
        else if (twoWaytieBreakersPageIdArray?.includes(parseInt(pageId)) && next_page_id_param == "953") {
          // console.log("tie breaker least fix")


          if (mostExists(testingVarsM) && !leastExists(testingVarsL)) {
            getLeastRound1StarterTieBreakers(testingVarsL, testingVarsM, strength_round1_l, mind_round1_l, soul_round1_l, heart_r1_l, 953, starterEdgeCaseCheck, starterEdgeCase1Check);
          }

          if (mostExists(testingVarsM) && leastExists(testingVarsL)) {
            navigate("/assessment/" + id + "/953");
          }

          // if ( isMost ) {
          //   const secondlastQuestion = questions[questions?.length - 2]
          //   secondlastQuestion?.answer > 0 && navigate("/assessment/" + id + "/953" + "/?" + removeNextSearchParam(searchParams), { replace: true });
          // }
          // else if ( !isMost ) {
          //   const lastQuestion = questions[questions?.length - 1]
          //   lastQuestion?.answer > 0 && navigate("/assessment/" + id + "/953" + "/?" + removeNextSearchParam(searchParams), { replace: true });
          // }


        }
        else if (pageId == 953) {
          // most tie breakers round 2
          if (mostExists(testingVarsM2)) {
            if (testingVarsM2.every(num => num === 0)) {
              setActiveStep(0)
              setIsLoading(false)
            }
          }
          else if (!mostExists(testingVarsM2)) {
            if (strength_r2 === mind_r2 && eliminate2wayEdgeCases(testingVarsM2, strength_r2, mind_r2)) {
              fetchTieBreakerQuestions(985, next_page_id);
              setIsMost(true)
            }
            else if (strength_r2 === heart_r2 && eliminate2wayEdgeCases(testingVarsM2, strength_r2, heart_r2)) {
              fetchTieBreakerQuestions(986, next_page_id);
              setIsMost(true)
            }
            else if (strength_r2 === soul_r2 && eliminate2wayEdgeCases(testingVarsM2, strength_r2, soul_r2)) {
              fetchTieBreakerQuestions(987, next_page_id);
              setIsMost(true)
            }
            else if (mind_r2 === heart_r2 && eliminate2wayEdgeCases(testingVarsM2, mind_r2, heart_r2)) {
              fetchTieBreakerQuestions(989, next_page_id);
              setIsMost(true)
            }
            else if (mind_r2 === soul_r2 && eliminate2wayEdgeCases(testingVarsM2, mind_r2, soul_r2)) {
              fetchTieBreakerQuestions(990, next_page_id);
              setIsMost(true)
            }
            else if (heart_r2 === soul_r2 && eliminate2wayEdgeCases(testingVarsM2, heart_r2, soul_r2)) {
              fetchTieBreakerQuestions(978, next_page_id);
              setIsMost(true)
            }
          }

          if (mostExists(testingVarsM2)) {
            setIsMost(null)
            setIsPauseScreen(true)
            navigate("/assessment/" + id + "/947" + "/?" + removeNextSearchParam(searchParams), { replace: true });
          }
        }
        else if (twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(pageId)) && next_page_id_param == "947") {
          setActiveStep(0)

          const edge_case = whichEdgeCase(testingVarsL2, testingVarsM2)

          console.log("updatedPayload", edge_case)
          if (edge_case == "edge_case_2") {
            const mostMaxValueAndIndex = testingVarsM2?.reduce((acc, curr, index) => {
              return curr > acc.value ? { value: curr, index } : acc
            }, { value: 0, index: -1 })

            let updatedPayload = testingVarsL2;
            updatedPayload[mostMaxValueAndIndex?.index] = testingVarsL2[mostMaxValueAndIndex?.index] - 2;

            console.log("updatedPayload", updatedPayload)
            console.log("updatedPayload testingVarsM2", testingVarsM2)
            resetScores(testingVarsM2, updatedPayload, 953, next_page_id, false, true);
          }

          if (mostExists(testingVarsM2) && edge_case == "no_edge_case") {
            setIsMost(null)
            setIsPauseScreen(true)
            navigate("/assessment/" + id + "/947");
          }
        }
        else if (pageId == 947) {
          // Leadership round 1 tie breaker

          // MOST tie breakers
          if (mostExists(testingVarsMLeadership)) {
            if (testingVarsMLeadership.every(num => num === 0)) {
              setActiveStep(0)
              setIsLoading(false)

            }
          }
          else if (!mostExists(testingVarsMLeadership)) {
            // Handle tie-breaking logic for "most"
            if (strategy_r1_m === vision_r1_m && strategy_r1_m === perform_r1_m) {
              fetchTieBreakerQuestions(960, next_page_id);
              setIsMost(true);
            } else if (strategy_r1_m === collab_r1_m && strategy_r1_m === perform_r1_m) {
              fetchTieBreakerQuestions(961, next_page_id);
              setIsMost(true);
            } else if (vision_r1_m === perform_r1_m && vision_r1_m === collab_r1_m) {
              fetchTieBreakerQuestions(962, next_page_id);
              setIsMost(true);
            } else if (strategy_r1_m === collab_r1_m && strategy_r1_m === vision_r1_m) {
              fetchTieBreakerQuestions(963, next_page_id);
              setIsMost(true);
            } else if (strategy_r1_m === perform_r1_m && eliminate2wayEdgeCases(testingVarsMLeadership, strategy_r1_m, perform_r1_m)) {
              fetchTieBreakerQuestions(964, next_page_id);
              setIsMost(true);
            } else if (vision_r1_m === perform_r1_m && eliminate2wayEdgeCases(testingVarsMLeadership, vision_r1_m, perform_r1_m)) {
              fetchTieBreakerQuestions(971, next_page_id);
              setIsMost(true);
            } else if (perform_r1_m === collab_r1_m && eliminate2wayEdgeCases(testingVarsMLeadership, perform_r1_m, collab_r1_m)) {
              fetchTieBreakerQuestions(972, next_page_id);
              setIsMost(true);
            } else if (vision_r1_m === strategy_r1_m && eliminate2wayEdgeCases(testingVarsMLeadership, vision_r1_m, strategy_r1_m)) {
              fetchTieBreakerQuestions(973, next_page_id);
              setIsMost(true);
            } else if (strategy_r1_m === collab_r1_m && eliminate2wayEdgeCases(testingVarsMLeadership, strategy_r1_m, collab_r1_m)) {
              fetchTieBreakerQuestions(974, next_page_id);
              setIsMost(true);
            } else if (vision_r1_m === collab_r1_m && eliminate2wayEdgeCases(testingVarsMLeadership, vision_r1_m, collab_r1_m)) {
              fetchTieBreakerQuestions(975, next_page_id);
              setIsMost(true);
            }
          }

          if (mostExists(testingVarsMLeadership) && !leastExists(testingVarsLLeadership)) {
            getLeastRound1LeadersTieBreakers(testingVarsLLeadership, testingVarsMLeadership, perform_r1_l, vision_r1_l, collab_r1_l, strategy_r1_l, id, searchParams, 954, leaderEdgeCase1Check);
          }

          const edge_case = whichEdgeCase(testingVarsLLeadership, testingVarsMLeadership)

          console.log("edge_case", edge_case)

          if (edge_case == "edge_case_3") {
            const mostMaxValueAndIndex = testingVarsMLeadership?.reduce((acc, curr, index) => {
              return curr > acc.value ? { value: curr, index } : acc
            }, { value: 0, index: -1 })



            const maxVal = Math.max(...testingVarsLLeadership);
            const secondMax = Math.max(...testingVarsLLeadership.filter(num => num !== maxVal));

            let updatedPayload = testingVarsLLeadership;
            updatedPayload[mostMaxValueAndIndex?.index] = secondMax - 1;

            console.log("updatedPayload", updatedPayload)
            console.log("updatedPayload secondMax", secondMax)
            console.log("updatedPayload testingVarsM", testingVarsMLeadership)
            resetScores(testingVarsMLeadership, updatedPayload, pageId, next_page_id, false, true);
          }

          if (mostExists(testingVarsMLeadership) && leastExists(testingVarsLLeadership)) {
            navigate("/assessment/" + id + "/954" + "/?" + removeNextSearchParam(searchParams), { replace: true });
          }

        }
        else if (threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(pageId)) && next_page_id_param == "954") {

          const edge_case = whichEdgeCase(testingVarsLLeadership, testingVarsMLeadership)

          console.log("edge_case", edge_case)

          if (edge_case == "edge_case_3") {
            const mostMaxValueAndIndex = testingVarsMLeadership?.reduce((acc, curr, index) => {
              return curr > acc.value ? { value: curr, index } : acc
            }, { value: 0, index: -1 })



            const maxVal = Math.max(...testingVarsLLeadership);
            const secondMax = Math.max(...testingVarsLLeadership.filter(num => num !== maxVal));

            let updatedPayload = testingVarsLLeadership;
            updatedPayload[mostMaxValueAndIndex?.index] = secondMax - 1;

            console.log("updatedPayload", updatedPayload)
            console.log("updatedPayload secondMax", secondMax)
            console.log("updatedPayload testingVarsM", testingVarsMLeadership)
            resetScores(testingVarsMLeadership, updatedPayload, pageId, next_page_id, false, true);
          }


          if (!mostExists(testingVarsMLeadership)) {
            getMostRound1LeaderTieBreakers(testingVarsMLeadership, strategy_r1_m, vision_r1_m, collab_r1_m, perform_r1_m, id, searchParams, 954)
          }

          if (leastExists(testingVarsLLeadership)) {
            if (testingVarsM.every(num => num === 0)) {
              if (testingVarsM.every(num => num === 0)) {
                // console.log('zero vals')
              }
            }
          }
          else if (mostExists(testingVarsMLeadership)) {
            getLeastRound1LeadersTieBreakers(testingVarsLLeadership, testingVarsMLeadership, perform_r1_l, vision_r1_l, collab_r1_l, strategy_r1_l, id, searchParams, 954, leaderEdgeCase1Check);
          }

          if (mostExists(testingVarsMLeadership) && leastExists(testingVarsLLeadership)) {
            navigate("/assessment/" + id + "/954" + "/?" + removeNextSearchParam(searchParams), { replace: true });
          }
        }
        else if (twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(pageId)) && next_page_id_param == "954") {

          const edge_case = whichEdgeCase(testingVarsLLeadership, testingVarsMLeadership)

          console.log("edge_case", edge_case)

          if (edge_case == "edge_case_3") {
            const mostMaxValueAndIndex = testingVarsMLeadership?.reduce((acc, curr, index) => {
              return curr > acc.value ? { value: curr, index } : acc
            }, { value: 0, index: -1 })



            const maxVal = Math.max(...testingVarsLLeadership);
            const secondMax = Math.max(...testingVarsLLeadership.filter(num => num !== maxVal));

            let updatedPayload = testingVarsLLeadership;
            updatedPayload[mostMaxValueAndIndex?.index] = secondMax - 1;

            console.log("updatedPayload", updatedPayload)
            console.log("updatedPayload secondMax", secondMax)
            console.log("updatedPayload testingVarsM", testingVarsMLeadership)
            resetScores(testingVarsMLeadership, updatedPayload, pageId, next_page_id, false, true);
          }


          if (mostExists(testingVarsMLeadership) && !leastExists(testingVarsLLeadership)) {
            getLeastRound1LeadersTieBreakers(testingVarsLLeadership, testingVarsMLeadership, perform_r1_l, vision_r1_l, collab_r1_l, strategy_r1_l, id, searchParams, 954, leaderEdgeCase1Check);
          }

          if (mostExists(testingVarsMLeadership) && leastExists(testingVarsLLeadership)) {
            navigate("/assessment/" + id + "/954" + "/?" + searchParams, { replace: true });
          }

        }
        else if (pageId == 954) {
          if (!mostExists(testingVarsMLeadershipRound2)) {
            if (perform_r2_m === strategy_r2_m && eliminate2wayEdgeCases(testingVarsMLeadershipRound2, perform_r2_m, strategy_r2_m)) {
              fetchTieBreakerQuestions(996, next_page_id);
              setIsMost(true);
            } else if (perform_r2_m === vision_r2_m && eliminate2wayEdgeCases(testingVarsMLeadershipRound2, perform_r2_m, vision_r2_m)) {
              fetchTieBreakerQuestions(997, next_page_id);
              setIsMost(true);
            } else if (perform_r2_m === collab_r2_m && eliminate2wayEdgeCases(testingVarsMLeadershipRound2, perform_r2_m, collab_r2_m)) {
              fetchTieBreakerQuestions(998, next_page_id);
              setIsMost(true);
            } else if (strategy_r2_m === vision_r2_m && eliminate2wayEdgeCases(testingVarsMLeadershipRound2, strategy_r2_m, vision_r2_m)) {
              fetchTieBreakerQuestions(999, next_page_id);
              setIsMost(true);
            } else if (strategy_r2_m === collab_r2_m && eliminate2wayEdgeCases(testingVarsMLeadershipRound2, strategy_r2_m, collab_r2_m)) {
              fetchTieBreakerQuestions(1000, next_page_id);
              setIsMost(true);
            } else if (vision_r2_m === collab_r2_m && eliminate2wayEdgeCases(testingVarsMLeadershipRound2, vision_r2_m, collab_r2_m)) {
              fetchTieBreakerQuestions(1001, next_page_id);
              setIsMost(true);
            }
          }

          if (mostExists(testingVarsMLeadershipRound2)) {
            setIsPauseScreen(true)
            navigate("/assessment/" + id + "/948" + "/?" + removeNextSearchParam(searchParams), { replace: true });
          }
        }
        else if (twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(pageId)) && next_page_id_param == "948") {
          setActiveStep(0);

          const edge_case = whichEdgeCase(testingVarsLLeadershipRound2, testingVarsMLeadershipRound2)

          console.log("updatedPayload", edge_case)
          if (edge_case == "edge_case_2") {
            const mostMaxValueAndIndex = testingVarsMLeadershipRound2?.reduce((acc, curr, index) => {
              return curr > acc.value ? { value: curr, index } : acc
            }, { value: 0, index: -1 })

            let updatedPayload = testingVarsLLeadershipRound2;
            updatedPayload[mostMaxValueAndIndex?.index] = testingVarsLLeadershipRound2[mostMaxValueAndIndex?.index] - 2;

            console.log("updatedPayload", updatedPayload)
            resetScores(testingVarsMLeadershipRound2, updatedPayload, 954, next_page_id, false, true);
          }

          if (mostExists(testingVarsMLeadershipRound2)) {
            setIsPauseScreen(true)
            navigate("/assessment/" + id + "/948" + "/?" + removeNextSearchParam(searchParams), { replace: true });
          }
        }
      }
      return data;
    } catch (error) {
      console.error("Error fetching results data:", error);
    }
  }

  const findSecondLargestAndCount = (arr) => {
    let sortedUnique = [...new Set(arr)].sort((a, b) => b - a);

    if (sortedUnique.length > 1) {
      let secondLargest = sortedUnique[1];
      let count = arr.filter(value => value === secondLargest).length;
      return { secondLargest, count };
    } else {
      return { secondLargest: null, count: 0 };
    }
  }

  const findIsEdgeCase1 = (leastArray, mostArray) => {
    const maxL = Math.max(...leastArray);
    const maxM = Math.max(...mostArray);

    let countMax = false;

    let leastIdxes = leastArray.reduce((acc, currentValue, currentIndex) => {
      if (currentValue === maxL) {
        acc.push(currentIndex);
      }
      return acc;
    }, []);

    let mostIdexs = mostArray.reduce((acc, currentValue, currentIndex) => {
      if (currentValue === maxM) {
        acc.push(currentIndex);
      }
      return acc;
    }, []);

    const areEqual = leastIdxes.length === mostIdexs.length && leastIdxes.every((val, index) => val === mostIdexs[index]);

    return areEqual;
  }

  function markAssessmentAsCompleted() {

    if (isCompleteAssessmentCalled || markAssessmentCompletedRef.current) {
      console.log("markAssessmentAsCompleted already called, skipping...");
      return;
    }
    
    // Set both flags to prevent multiple calls
    setIsCompleteAssessmentCalled(true);
    markAssessmentCompletedRef.current = true;
    setIsLoading(true);
    
    fetch(process.env.REACT_APP_API_URI + '/v3/user/' + id + '/completed', {
      method: 'PUT', mode: 'cors', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ hash: id }),
    }).then(response => {
      return response.json();
    }).then(data => {
      if (data.status === "success") {
        setIsLoading(false);
        const assessmentName = localStorage.getItem("assessmentName");
        // navigate(`/${assessmentName}/outro/${id}/?${searchParams}`, { replace: true });
        console.log("resultData",resultData)
        if (!resultData.parentHash) {
          if (hasLeader) {
            navigate(`/outro/${id}` + removeNextSearchParam(searchParams), { replace: true });
            localStorage.removeItem('selectedAnswers')
          }
          else {
            localStorage.removeItem('selectedAnswers')
            setHasNotified(false)
            navigate(`/results/${id}`, { replace: true });
          }
        } 
        else {
          const userName = JSON.parse(localStorage?.getItem(`searchParams-${id}`));
          console.log("leaderName", userName)
          console.log("leaderName", userName?.leader)

          if ( resultData?.designation === "Self-Assessment" ||  resultData?.designation === "360 Assessment" ) {
            localStorage.removeItem('selectedAnswers')
            setHasNotified(false)
            navigate(`/results/${id}`, { replace: true });
          }
          else if (userName && userName.leader !== null) {
            navigate(`/assessment-thanks/${id}?leader=${userName?.leader}`)
          }
          else if (userName && userName.selfUserName !== null) {
            navigate(`/assessment-thanks/${id}?selfUserName=${userName?.selfUserName}`)
          }
          // navigate(`/assessment-thanks/${id}`)
          localStorage.removeItem('selectedAnswers')
        } //IF USER HAS PARENT HASH, REDIRECT TO THANKS PAGE
      }
    }).catch(error => {
      console.error("Failed to mark assessment as completed...", error);
      setIsLoading(false);
      setIsCompleteAssessmentCalled(false);
      markAssessmentCompletedRef.current = false;
    })
  }

  // console.log("searchParams", [...searchParams]);

  const retrieveStoredAnswers = () => {
    if (typeof window !== 'undefined') {
      // Get the current localstorage
      let savedAnswers = JSON.parse(localStorage.getItem("assessmentAnswers"));
      if (savedAnswers && savedAnswers.length > 0) {
        return savedAnswers;
      }
    }
    return;
  }

  const handleTieBreakerBackward = () => {
    const previousTieBreakerPage = twoWaytieBreakersPageIdArray.includes(pageId) ? '866' : '953';
    // console.log("previousTieBreakerPage", previousTieBreakerPage)
    navigate(`/assessment/${id}/${previousTieBreakerPage}/?${removeNextSearchParam(searchParams)}`, { replace: true });
  };

  if (twoWaytieBreakersPageIdArray.includes(parseInt(pageId)) || threeWaytieBreakersPageIdArray.includes(parseInt(pageId))) {
    // console.log("Tie-breaker logic active");
  }

  const prevQuestion = () => {
    setPrevBtnClicked(true);
    setBackButtonClicked(true)
    if (activeStep == 0 || isTieBreaker) {
      setProgressBack(true)
      setProgressNext(false)
    }
    else {
      setProgressBack(false)
    }
    console.log("Navigating Backward - activeStep:", activeStep, "pageId:", pageId);
    // if(activeStep < 1) {
    //   // if(searchParams.get("member")) {
    //   if([...searchParams]?.length) {
    //     // navigate("/start?member=" + searchParams.get("member"), { replace: true });
    //     navigate("/start?" + searchParams, { replace: true });
    //   } else navigate("/start", { replace: true });
    // } else {
    //   setActiveStep(activeStep - 1);
    //   setPrevValue(questions?.[activeStep - 1].answer);
    // }


    if (isPauseScreen && (pageId == "947" || pageId == "948")) {
      setIsPauseScreen(false)
      navigateBackwardFunc();
    }


    if (activeStep == 0 && !isPauseScreen && (pageId == "947" || pageId == "948")) {
      setIsPauseScreen(true)
      return;
    }
    else {
      setIsPauseScreen(false)
    }

    const isTwoWay = twoWaytieBreakersPageIdArray?.includes(parseInt(pageId)) || twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(pageId)) || twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(pageId)) || twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(pageId))
    const isThreeWay = threeWaytieBreakersPageIdArray?.includes(parseInt(pageId)) || threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(pageId))
    const isPrevPauseScreenPage = twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(pageId)) || pageId == "953"
    const isPrevPauseScreenPageLeadership = twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(pageId)) || pageId == "954"

    if ((activeStep > 0 && !(isTwoWay && !isMost) && !(isThreeWay && !isMost && activeStep <= 4)) && !(isTwoWay && isMost && activeStep >= 1)) {
      if (pageId == 953 || pageId == 954) {
        setActiveStep((prev) => Math.max(prev - 2, 0));
      } else {
        setActiveStep((prev) => Math.max(prev - 1, 0));
      }
      setPrevValue(questions?.[activeStep - 1]?.answer || null);
    }
    else if (isTwoWay || isThreeWay || pageId == "953" || pageId == "947" || pageId == "954" || pageId == "948") {

      if (isPrevPauseScreenPage || isPrevPauseScreenPageLeadership) {
        !isPauseScreen && navigateBackwardFunc();
      }
      else {
        navigateBackwardFunc();
      }
      // handleTieBreakerBackward();
    }
    else if (activeStep === 0 && pageId == "866") {
      navigate(`/get-started/${id}`, { replace: true });
    }

    if (isPauseScreen) {
      if (pageId == "953" || pageId == "954") {
        setActiveStep(questions?.length - 2)
      }
    }

    // else {
    //   navigateBackwardFunc();
    // }
  };

  // const nextQuestion = () => { 
  //   // // if(activeStep == questions?.length - 1) {
  //   // //   setTimeout(() => { completeAssessment(); }, 500);
  //   // // } else if(activeStep < questions?.length - 1) {
  //   // //   setTimeout(() => {
  //   // //     setActiveStep(activeStep + 1);
  //   // //     setPrevValue(questions?.[activeStep + 1].answer);
  //   // //   }, 20);

  //   assessCtx.updateAnswer(questions?.[activeStep]?.id, questions?.[activeStep]?.answer);
  //   assessCtx.updateTextAnswer(questions?.[activeStep]?.id, questions?.[activeStep]?.answerTxt);

  //   let mandatory = questions?.[activeStep]?.mandatory;
  //   let questionIsMandatory = mandatory === "yes" || mandatory === "true" || mandatory === true;
  //   let questionIsAnswered = questions?.[activeStep]?.answer > 0 || questions[activeStep]?.answerTxt?.trim()?.length > 0;

  //   // else if (hasAdditional) {
  //   //   // if(searchParams.get("member") != null) {
  //   //     if (searchParams?.get("member")) {
  //   //       navigate("/assessment-additional/" + currentHash + "?" + searchParams, { replace: true });
  //   //     } else {
  //   //       navigate("/pre-additional-info/" + currentHash + "?" + searchParams, { replace: true });
  //   //     }
  //   // } else {
  //   //   // if(searchParams.get("member") != null) {
  //   //   if(searchParams.get("member") && currentHash) {
  //   //     navigate("/details/" + currentHash + "?" + searchParams, { replace: true });
  //   //   } else {
  //   //     console.log("\nSUBMITTING ANSWERS\n");
  //   //     setTimeout(() => { completeAssessment(); }, 500);
  //   //   }
  //   // }

  //   if (activeStep < questions?.length - 1) {
  //     if (questionIsMandatory) {
  //       if (questionIsAnswered) {
  //         setActiveStep((prev) => prev + 1);
  //       }
  //     } else if (!questionIsMandatory) {
  //       if (questionIsAnswered) {
  //         setActiveStep((prev) => prev + 1);
  //       } else {
  //         if (questions?.[activeStep]?.answerType === "textarea") {
  //           assessCtx.updateTextAnswer(questions?.[activeStep].id, "");
  //         }
  //         setActiveStep((prev) => prev + 1);
  //       }
  //     }
  //   } else {
  //     // navigateForwardFunc();
  //     if (questionIsMandatory) {
  //       if (questionIsAnswered) {
  //         setTimeout(() => { completeAssessment(); }, 500);
  //       }
  //     } else if (!questionIsMandatory) {
  //       if (!questionIsAnswered) {
  //         if (questions?.[activeStep]?.answerType === "textarea") {
  //           assessCtx.updateTextAnswer(questions?.[activeStep].id, "");
  //         }
  //       }
  //       setTimeout(() => { completeAssessment(); }, 500);
  //     }
  //   }

  // };




  const nextQuestion = () => {
    setIsPauseScreen(false)
    assessCtx.updateAnswer(questions?.[activeStep]?.id, questions?.[activeStep]?.answer);
    assessCtx.updateTextAnswer(questions?.[activeStep]?.id, questions?.[activeStep]?.answerTxt);

    if (activeStep == questions?.length - 1 || isTieBreaker || (isPauseScreen && pageId == "947") || ((pageId == "954" || pageId == "953") && activeStep == questions?.length - 2)) {
      setProgressNext(true)
      setProgressBack(false)
    }
    else {
      setProgressNext(false)
    }

    let mandatory = questions?.[activeStep]?.mandatory;
    let questionIsMandatory = mandatory === "yes" || mandatory === "true" || mandatory === true;
    let questionIsAnswered = questions?.[activeStep]?.answer > 0 || questions[activeStep]?.answerTxt?.trim()?.length > 0;
    let isTwoWay = twoWaytieBreakersPageIdArray?.includes(parseInt(pageId)) || twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(pageId)) || twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(pageId)) || twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(pageId))
    let isThreeWay = threeWaytieBreakersPageIdArray?.includes(parseInt(pageId)) || threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(pageId))

    console.log('activestep-isThreeWay', activeStep, isThreeWay)
    if ((activeStep < questions?.length - 1) && !(pageId == "953" || pageId == "954" || (isTwoWay && isMost) || (isThreeWay && isMost))) {
      if (pageId == "953" || pageId == "954") {
        setActiveStep((prev) => prev + 2)
      }
      else {
        setActiveStep((prev) => prev + 1)
      }
    }
    else {
      moveToNextQuestion(questions?.[activeStep]?.answer, true)
    }

    isPauseScreen && setActiveStep(0)

  };

  const submitAnswer = (answer) => {
    const jsonBody = {
      questions: [
        {
          "id": questions?.[activeStep]?.id,
          "answer": answer,
          "answerTxt": null
        }
      ],
    }
    // console.log(jsonBody);
    fetch(process.env.REACT_APP_API_URI + '/v3/user/assessment/' + id, {
      method: 'PUT',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(jsonBody)
    }).then(response => {
      return response.json();
    }).then(data => {
      if (data.status === "success") {
        // navigate("/assessment/" + id + "/" + pageId + "/?" + searchParams, { replace: true });
        // save the answer option so you see the selected option when going back & forth between questions 
        questions[activeStep].answer = answer;
        if (activeStep < (questions?.length - 1)) {
          setActiveStep(activeStep + 1);
          // setPrevValue(questions?.[activeStep + 1].answer);
        } else {
          // navigate(navigatePath, { replace: true });
          navigateForwardFunc();
        }
        // console.log("data", data);
      } else {
        // setIsSaving(false);
        // setOpenSnackbar(true);
      }
    }).catch((err) => console.error("Failed to send answer details...", err));
  }

  // console.log("activeStep", activeStep);
  // console.log("orderNo", questions?.[activeStep]?.orderNo, typeof questions?.[activeStep]?.orderNo);
  const navigatePath = (pgId) => "/assessment/" + id + "/" + pgId + "/?" + removeNextSearchParam(searchParams);
  const navigateForwardFunc = () => {
    if (pageId === "28") {
      navigate("/charts/" + id + "/29?" + removeNextSearchParam(searchParams), { replace: true });
    } else if (pageId === "30") {
      navigate("/charts/" + id + "/31?" + removeNextSearchParam(searchParams), { replace: true });
    } else if (pageId === "32") {
      navigate("/charts/" + id + "/33?" + removeNextSearchParam(searchParams), { replace: true });
    } else if (pageId === "34") {
      navigate("/charts/" + id + "/35?" + removeNextSearchParam(searchParams), { replace: true });
    } else if (pageId === "36") {
      navigate("/charts/" + id + "/37?" + removeNextSearchParam(searchParams), { replace: true });
    } else if (pageId === "804") {
      navigate("/assessment-additional/" + id + "/805?" + removeNextSearchParam(searchParams), { replace: true });
    }
  }

  const navigateBackwardFunc = () => {
    setIsLoading(true)
    const allPageIdMap = assessCtx?.allQuestions?.map((el) => { return el?.pageId })
    const currentPageId = (element) => element == pageId
    const prevIndex = allPageIdMap?.findIndex(currentPageId) - 1

    console.log("prevIndex", prevIndex)

    if (prevIndex >= 0) {
      const prevPageId = allPageIdMap[prevIndex]
      const prevPageIdObj = assessCtx?.allQuestions?.find((el) => el?.pageId === prevPageId)
      const isTwoWay = twoWaytieBreakersPageIdArray?.includes(parseInt(prevPageId)) || twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(prevPageId)) || twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(prevPageId)) || twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(prevPageId))
      const isThreeWay = threeWaytieBreakersPageIdArray?.includes(parseInt(prevPageId)) || threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(prevPageId))

      console.log("prevPageId", prevPageId)

      let next_page_id = "0";

      if (twoWaytieBreakersPageIdArray?.includes(parseInt(prevPageId)) || threeWaytieBreakersPageIdArray?.includes(parseInt(prevPageId))) next_page_id = 953
      else if (twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(prevPageId))) next_page_id = 947
      else if (twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(prevPageId)) || threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(prevPageId))) next_page_id = 954
      else if (twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(prevPageId))) next_page_id = 948

      if (prevPageId == "866" || prevPageId == "947" || prevPageId == "948" || prevPageId == "953" || prevPageId == "954") {
        setBackFromTieBreaker(true)
        navigate(`/assessment/${id}/${prevPageId}`)
        setIsMost(prevPageIdObj?.isMost)
        setIsLoading(false)
      }
      else if (isTwoWay) {
        setBackFromTieBreaker(true)
        setIsMost(prevPageIdObj?.isMost)
        resetScores(prevPageIdObj?.mostScores, prevPageIdObj?.leastScores, prevPageId, next_page_id, true, false)
        // console.log("allPageIdMap-assessCtx?.allQuestions-prevPageIdObj-isReset", allPageIdMap, assessCtx?.allQuestions,prevPageIdObj,isReset)
      }
      else if (isThreeWay) {
        setBackFromTieBreaker(true)
        setIsMost(prevPageIdObj.isMost)
        resetScores(prevPageIdObj?.mostScores, prevPageIdObj?.leastScores, prevPageId, next_page_id, true, false)
        // navigate(`/assessment/${id}/${prevPageId}/?next_page=953`)
      }
    }
  }

  const resetScores = (mostScores, leastScores, prev_page_id, next_page_id, isNavigate, isTieBreaker) => {

    let isReview = false;
    if (id != null) {
      isReview = true;
    }

    console.log(prev_page_id)
    // starterMostPayload() accepts the payload and resets the round1 total variables as you want. preferred use is while backing up

    const isStarterRound1 = twoWaytieBreakersPageIdArray?.includes(parseInt(prev_page_id)) || threeWaytieBreakersPageIdArray?.includes(parseInt(prev_page_id)) || prev_page_id == 866;
    const isStarterRound2 = twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(prev_page_id)) || prev_page_id == 953;
    const isLeadershipRound1 = twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(prev_page_id)) || threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(prev_page_id)) || prev_page_id == 947;
    const isLeadershipRound2 = twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(prev_page_id)) || prev_page_id == 954;

    let questionPayload;
    let payload_page_id;
    if (isStarterRound1) {
      questionPayload = starter_reset_payload_round1(...mostScores, ...leastScores)
      payload_page_id = 1004;
    }
    else if (isStarterRound2) {
      questionPayload = starter_reset_payload_round2(...mostScores, ...leastScores)
      payload_page_id = 1010;
    }
    else if (isLeadershipRound1) {
      questionPayload = leader_reset_payload_round1(...mostScores, ...leastScores)
      payload_page_id = 1005;
    }
    else if (isLeadershipRound2) {
      questionPayload = leader_reset_payload_round2(...mostScores, ...leastScores)
      payload_page_id = 1011;
    }

    const jsonBody = { pageId: payload_page_id, questions: questionPayload, isReview: isReview }

    fetch(process.env.REACT_APP_API_URI + '/v3/user/assessment/' + id, {
      method: 'PUT', mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(jsonBody)
    }).then(response => {
      return response.json();
    }).then(data => {
      if (data.status === "success") {
        fetchResults(parseInt(pageId), next_page_id, isTieBreaker).then(result => {
          if (isNavigate && result) {
            setTimeout(() => {
              navigate(`/assessment/${id}/${prev_page_id}/?next_page=${next_page_id}`);
              setIsLoading(false)
            }, 500);
          }
        });

        return true;
      }
    })
      .catch(error => {
        console.error('Error resetting scores:', error);
      });
  }

  console.log('paramData', paramData)

  const postNotifications = async () => {

    let notificationType = "";
    let actionType = "";
    let message = "";
    let actionLink

    const capitalizeWords = (str) => { return str?.replace(/\b\w/g, (char) => char.toUpperCase()) || ''; };

    const memberName = capitalizeWords(paramData.member);
    const leaderName = capitalizeWords(paramData.leader);
    const clientName = capitalizeWords(paramData.clientName);

    if ( isLastAsmt ) {
      notificationType = "all_complete";
      actionType = "go_to_360_report";
      message = "All assessments completed!";
      actionLink = `https://d23l6nw9jmhz3t.cloudfront.net/results/${id}`;
    }
    else if (!hasLeader && !isLastAsmt) {
      notificationType = "self_complete";
      actionType = "go_to_results";
      message = "You have completed Self assessment!";
      actionLink = `https://d23l6nw9jmhz3t.cloudfront.net/results/${id}`;
    }
    else if ( hasLeader && !isLastAsmt ) {
      notificationType = "360_complete";
      actionType = "go_to_clients";
      message = `<strong>${memberName}</strong> has completed the 360 Assessment for <strong>${leaderName}</strong> <strong>(Client: ${clientName})</strong>.`;
      actionLink = `https://d1xqw9fxllglrv.cloudfront.net/clients`
    }

    const searchParamsLs = JSON.parse(localStorage.getItem(`searchParams-${id}`))
    console.log("notification searchParamsLs", searchParamsLs)

    if (searchParamsLs?.orgId && searchParamsLs?.clientId) {
      console.log("notification success")
      await sendNotifications({
        action: actionType,
        action_link: actionLink,
        msg: message,
        user_name: getUserNameForNotifications( isLastAsmt, searchParamsLs, hasLeader ),
        type: notificationType,
        orgId: searchParamsLs?.orgId,
        asmtId: id,
        clientId: searchParamsLs?.clientId
      });
    }

  }

  const getUserNameForNotifications = ( isLastAsmt, searchParamsLs, hasLeader ) => {
    console.log("isLastAsmt,searchParamsLs,hasLeader",isLastAsmt,searchParamsLs,hasLeader)
    if ( isLastAsmt ) {
      if ( hasLeader ) {
        return searchParamsLs?.leader;
      }
      else {
        return searchParamsLs?.userName;
      }
    }
    else {
      return resultData.fullName;
    }
  }

  const moveToNextQuestion = (answer, immediately) => {
    setBackFromTieBreaker(false)
    setAutoSubmit(true)
    setProgressBack(false)

    console.log("notification fetchedQuestions,activeStep,hasNotified",fetchedQuestions,activeStep,hasNotified)

    if (!hasNotified && !fetchedQuestions?.[fetchedQuestions?.length-1]?.answer > 0 && activeStep == 11 && pageId === "948") {
      setHasNotified(true)
      postNotifications()
    }

    // if (activeStep == 11 && pageId === "948") {
    //   // setHasNotified(true)
    //   postNotifications()
    // }

    // Update answer
    questions[activeStep].answer = answer;
    setQuestions(prevQuestions =>
      prevQuestions.map((q, index) =>
        index === activeStep ? { ...q, answer } : q
      )
    );
    assessCtx.updateAnswer(questions?.[activeStep]?.id, answer);
    // updateProgress(assessCtx?.allQuestions) // saved progress functionality


    if (isTieBreaker) {
      console.log("isMost,pageId", isMost, pageId)
      if (isMost) {
        questions[1].answer = 0;
      }
      else {
        questions[0].answer = 0;
      }
    }

    if (activeStep == questions?.length - 1 || (pageId == "953" && activeStep == questions?.length - 2) || (pageId == "954" && activeStep == questions?.length - 2) || isTieBreaker) {
      setProgressNext(true)
      setProgressBack(false)
    }
    else {
      setProgressNext(false)
    }


    // for progressbar animation

    const isR2TwoWay = twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(pageId)) || twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(pageId))
    const isThreeWay = threeWaytieBreakersPageIdArray?.includes(parseInt(pageId)) || threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(pageId))


    // console.log("questions-activeStep", questions, activeStep)
    // Navigation logic
    if (activeStep < questions?.length - 1 && !(isR2TwoWay && isMost)) {
      if (immediately) {
        setActiveStep(activeStep + 1);
      }
      else {
        setTimeout(() => {
          setActiveStep(activeStep + 1);
        }, 500);
      }
    }
    else {
      // questions?.[activeStep].answer = answer;
      const round1_tiebreakers_starter = [970, 955, 956, 957, 958, 969, 966, 967, 968, 959]
      const round2_tiebreakers_starter = [978, 979, 980, 981, 982, 990, 986, 987, 989, 985]

      const round1_tiebreakers_leadership = [965, 960, 961, 962, 963, 964, 971, 972, 973, 974, 975]
      const round2_tiebreakers_leadership = [984, 991, 993, 994, 995, 996, 997, 998, 999, 1000, 1001]
      if (pageId === '866') {
        getTieBreakers(953, 'round1')
      }
      else if (pageId === '953') {
        getTieBreakers(947, 'round2')
      }
      else if (pageId === '947') {
        getTieBreakers(954, 'round1')
      }
      else if (pageId === '954') {
        getTieBreakers(948, 'round2')
      }
      else if (pageId === '948') {
        setTimeout(() => { completeAssessment(); }, 500);
      }
      else if (round1_tiebreakers_starter?.includes(parseInt(pageId))) {
        getTieBreakers(953, 'round1')
      }
      else if (round2_tiebreakers_starter?.includes(parseInt(pageId))) {
        getTieBreakers(947, 'round1')
      }
      else if (round1_tiebreakers_leadership?.includes(parseInt(pageId))) {
        getTieBreakers(954, 'round1')
      }
      else if (round2_tiebreakers_leadership?.includes(parseInt(pageId))) {
        console.log("here")
        getTieBreakers(948, 'round1')
      }
    }
  };

  const updateProgress = async (allQuestions) => {
    const fetchedProg = await fetchAssessmentProgress(id)
    const fetchedProgAllQuestions = fetchedProg?.data?.flatMap(el => el?.data || []);
    const lsAllQuestions = allQuestions?.flatMap(el => el?.data || []);
    let fetchedQIndex = fetchedProgAllQuestions?.findIndex(item => item.answer === undefined);
    let lsQIndex = lsAllQuestions?.findIndex(item => item.answer === undefined);
    const currentPageIdQs = fetchedProg?.data?.find((el) => el?.pageId == pageId)

    // console.log("currentPageIdQs?.data, questions, lsQIndex, fetchedQIndex", currentPageIdQs?.data, questions, lsQIndex, fetchedQIndex)
    // if (fetchedProg?.data?.[0]?.data?.[0]?.answer > 0) {
    //   if (!isEqual(currentPageIdQs?.data, questions)) {
    //     const response = await updateAssessmentProgress(id, allQuestions)
    //   }
    // }
    // else if (!fetchedProg?.data || fetchedProg?.data?.length == 0) { // only updates when metas[] is null in /assessment-progress
    //   const response = await updateAssessmentProgress(id, allQuestions)
    // }
  }

  const getTieBreakers = async (next_page_id, round, mostLeastLast) => {

    if (pageId == '866' || pageId == "947") {
      setTimeout(() => {
        setIsLoading(true)
      }, 400);
    }
    else {
      setIsLoading(true)
    }

    const lastQuestion = questions[questions?.length - 1]
    const secondLastQuestion = questions[questions?.length - 2]
    const isR2TwoWay = twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(pageId)) || twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(pageId))

    console.log("getTieBreakers lastQuestion", lastQuestion)
    console.log("getTieBreakers secondLastQuestion", secondLastQuestion)
    console.log("getTieBreakers questions", questions)

    if (mostLeastLast?.answer > 0) {
      completeAssessment("no-load", next_page_id);
    }
    else if ((!lastQuestion?.answer > 0 || ((pageId == 953 || pageId == 954) && !secondLastQuestion?.answer > 0)) && !(isR2TwoWay && isMost && secondLastQuestion?.answer > 0)) {
      setActiveStep(0)
      // setIsLoading(false)
    }
    else {
      completeAssessment("no-load", next_page_id);
    }
  };

  const allQuestionsAnswered = (questions) => {
    for (const element of questions) {
      if (element?.answer === undefined || element?.answer === 0) {
        return false;
      }
    }
    return true;
  };

  const fetchTieBreakerQuestions = (page_id, next_page_id) => {
    fetch(`${process.env.REACT_APP_API_URI}/v3/user/assessment/${id}/pages/${page_id}`, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' }
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          // console.log(data);
          console.log(data?.data?.questions);
          if (data?.data?.questions?.pageId === 955 || 956 || 957 || 958 || 949 || 959 || 966 || 967 || 968 || 969 || 970 || 985 || 986 || 987 || 989 || 990 || 978) {
            setQuestionType("Starter")
          }
          else if (data?.data?.questions?.pageId === 960 || 961 || 962 || 963 || 965 || 964 || 971 || 964 || 972 || 973 || 974 || 975 || 984 || 996 || 997 || 998 || 999 || 1000 || 1001) {
            setQuestionType("Leadership")
          } else {
            setQuestionType("")
          }
          setTiebreakerQuestionCount(data?.data?.questions.length)
          setIsLoading(false)
          let tieBreakerQuestions = data.data?.questions;
          let questionsIdMap = questions?.map((el) => el?.pageId);

          if (!questionsIdMap?.includes(page_id)) {
            // setQuestions([
            //   ...questions,
            //   ...tieBreakerQuestions,
            // ]);

            navigate("/assessment/" + id + `/${page_id}` + "/?" + `next_page=${next_page_id}` + removeNextSearchParam(searchParams), { replace: true });
          }
        } else {
          // Uncomment and handle snackbar logic if needed
          // setOpenSnackbar(true);
        }
      })
      .catch((err) => console.error("Error while fetching questions...", err));
  };

  const getPreviousCompletedQuestions = () => {
    if (pageId === '866') {
      return 0;
    }
    else if (pageId === '953') {
      return 20;
    }
    else if (pageId === '947') {
      return 40;
    }
    else if (pageId === '954') {
      return 60;
    }
    else if (pageId === '948') {
      return 80;
    }
  }

  const updateTextAnswer = (id, textVal) => {
    setQuestions(questions?.map((q) => {
      if (q.id === id) q.answerTxt = textVal;
      return q;
    }))
  }

  const updateCheckboxQuestion = (id, checkboxAnswers) => {
    setQuestions(questions?.map((q) => {
      if (q.id === id) {
        q.answers = checkboxAnswers;
      }
      return q;
    }));
  }

  const questionsPerSection = [tiebreakerQuestionCount > 0 && questionType === "Starter" ? tiebreakerQuestionCount + 40 : 40, tiebreakerQuestionCount > 0 && questionType === "Leadership" ? tiebreakerQuestionCount + 40 : 40, 12];

  const modifyString = (input) => {
    const match = input.match(/(\d+)/);
    if (match) {
      const number = parseInt(match[0], 10);
      const modifiedNumber = number - 10;
      return input.replace(match[0], modifiedNumber.toString());
    }
    return input;
  };

  function removeOptionSelectedInPrevQuestion(ans, question) {
    // console.log("assessCtx.allQuestions", assessCtx.allQuestions)
    let currentQVar = question?.variable;
    if (currentQVar?.includes('pass2') && (question?.pageId == 866 || question?.pageId == 947)) {
      let searchVar = currentQVar.replace("pass2", "pass1");
      const searchQ = assessCtx.questions?.find((el) => el?.variable == searchVar);
      // console.log("searchQ-ans", searchQ, ans)

      if (searchQ?.answer == ans.value) return true
    }
    else if (question?.pageId == 954 || question?.pageId == 953) {
      let searchVarPass1 = currentQVar.replace("pass2", "pass1");
      let searchVarPass2 = searchVarPass1.replace("pass1", "pass2");
      let modifiedVarPass1 = modifyString(searchVarPass1);
      let modifiedVarPass2 = modifyString(searchVarPass2);
      let currentPageId = question?.pageId === 953 ? 866 : question?.pageId === 954 && 947;
      let firstRoundQuestions = assessCtx?.allQuestions?.find((el) => el?.pageId == currentPageId)?.data
      let searchQ1 = firstRoundQuestions?.find((el) => el?.variable == modifiedVarPass1);
      let searchQ2 = firstRoundQuestions?.find((el) => el?.variable == modifiedVarPass2);
      let searchQ3 = questions?.find((el) => el?.variable == searchVarPass1);

      const mostMaxValueAndIndex = testingVarsM?.reduce((acc, curr, index) => {
        return curr > acc.value ? { value: curr, index } : acc
      }, { value: 0, index: -1 })

      const mostMaxValueAndIndexLeadership = testingVarsMLeadership?.reduce((acc, curr, index) => {
        return curr > acc.value ? { value: curr, index } : acc
      }, { value: 0, index: -1 })

      const leastMaxValue = testingVarsL?.reduce((acc, curr, index) => {
        return curr > acc.value ? { value: curr, index } : acc
      }, { value: 0, index: -1 })

      const leastMaxValueLeadership = testingVarsLLeadership?.reduce((acc, curr, index) => {
        return curr > acc.value ? { value: curr, index } : acc
      }, { value: 0, index: -1 })


      // console.log("modifiedVarPass1-modifiedVarPass2-searchVarPass1-searchVarPass2-assessCtx?.questions-searchQ3-searchQ2,searchQ1-currentQVar: ", modifiedVarPass1, modifiedVarPass2, searchVarPass1, searchVarPass2, assessCtx?.questions, searchQ3, searchQ2, searchQ1, currentQVar)
      // if (searchQ1?.answer == ans.value || searchQ2?.answer == ans.value || (searchQ3?.answer == ans.value && currentQVar?.includes("pass2"))) return true

      if (pageId == "953") {
        if (mostMaxValueAndIndex?.index + 1 == ans.value || leastMaxValue?.index + 1 == ans.value || (searchQ3?.answer == ans.value && currentQVar?.includes("pass2"))) return true
      }
      else if (pageId == "954") {
        if (mostMaxValueAndIndexLeadership?.index + 1 == ans.value || leastMaxValueLeadership?.index + 1 == ans.value || (searchQ3?.answer == ans.value && currentQVar?.includes("pass2"))) return true
      }
    }
    return false;
  }

  function findIsValidAns(ans) {


    const hrt_m = variableMapArray["heart_round1_m"]
    const soul_m = variableMapArray["soul_round1_m"]
    const mind_m = variableMapArray["mind_round1_m"]
    const str_m = variableMapArray["str_round1_m"]

    const hrt_l = variableMapArray["heart_round1_l"]
    const soul_l = variableMapArray["soul_round1_l"]
    const mind_l = variableMapArray["mind_round1_l"]
    const str_l = variableMapArray["str_round1_l"]

    const per_m = variableMapArray["per_round1_m"]
    const strat_m = variableMapArray["strat_round1_m"]
    const vis_m = variableMapArray["vis_round1_m"]
    const col_m = variableMapArray["col_round1_m"]

    const per_l = variableMapArray["per_round1_l"]
    const strat_l = variableMapArray["strat_round1_l"]
    const vis_l = variableMapArray["vis_round1_l"]
    const col_l = variableMapArray["col_round1_l"]




    let mostArray = [];
    let leastArray = [];

    if (pageId == 953) {
      mostArray = [hrt_m, soul_m, mind_m, str_m]
      leastArray = [hrt_l, soul_l, mind_l, str_l]
    }
    else if (pageId == 954) {
      mostArray = tieBreakersLeaderShip?.most
      leastArray = tieBreakersLeaderShip?.least
    }


    console.log("mostArray--leastArray--variableMapArray", mostArray, leastArray, variableMapArray)

    // const currentPageIdMostArray = assessCtx?.allQuestions?.find((el) => el?.pageId == pageId)?.mostScores
    // const currentPageIdLeastArray = assessCtx?.allQuestions?.find((el) => el?.pageId == pageId)?.leastScores

    const currentPageIdMostArray = mostArray;
    const currentPageIdLeastArray = leastArray;

    const maxIndex = currentPageIdMostArray?.indexOf(Math.max(...currentPageIdMostArray)) + 1;
    const leastIndex = currentPageIdLeastArray?.indexOf(Math.max(...currentPageIdLeastArray)) + 1;
    console?.log("assessCtx?.allQuestions--ans--currentPageIdMostArray--currentPageIdLeastArray--maxIndex--leastIndex", assessCtx?.allQuestions, ans, currentPageIdMostArray, currentPageIdLeastArray, maxIndex, leastIndex)

    if (ans?.value == maxIndex || ans?.value == leastIndex) return false;

    return true;
  }

  const getStepContent = (step) => {

    // hiding most least logic
    // starter quadrant 
    // leadership quadrant 
    // console.log("step, pageId", step, pageId)

    // const currentQPageId = questions[step]?.pageId;

    if (!backFromTieBreaker && autoSubmit && (pageId === '953' || pageId === '954') && (step + 1) < questions?.length && step % 2 !== 0) {

      moveToNextQuestion(getUnselectedOption(questions[step - 1]), true);
      setActiveStep(step + 1);
      return;
    }
    else if (!backFromTieBreaker && autoSubmit && (pageId === '953' || pageId === '954') && (step + 1) === questions?.length) {
      moveToNextQuestion(getUnselectedOption(questions[step - 1]), true);
    }
    else if (
      !backFromTieBreaker && autoSubmit &&
      (twoWaytieBreakersPageIdArray.includes(parseInt(pageId)) || threeWaytieBreakersPageIdArray.includes(parseInt(pageId)) ||
        twoWaytieBreakersPageIdArrayRound2.includes(parseInt(pageId)) ||
        twoWaytieBreakersPageIdArrayLeadership.includes(parseInt(pageId)) || threeWaytieBreakersPageIdArrayLeadership.includes(parseInt(pageId))
      )
    ) {

      // search most least hide for useeffect that is changing activestep
      const currentQuestion = questions[step];

      const allMostQuestions = questions?.filter((el) => !el.variable?.includes("_l"));
      const allLeastQuestions = questions?.filter((el) => el.variable?.includes("_l"));
      const first_least_question = allLeastQuestions.at(0)
      const last_least_question = allLeastQuestions.at(-1)
      const leastCount = questions?.length - allMostQuestions?.length;
      // console.log("first_least_question,last_least_question-currentQuestion-activeStep-nextPageIdParam-isMost-allLeastQuestions-questions", first_least_question, last_least_question, currentQuestion, activeStep, nextPageIdParam, isMost,allLeastQuestions,questions)

      if (isMost) {
        if (first_least_question?.id == currentQuestion?.id) {
          questions?.forEach((element, index, array) => {
            if (element.variable?.includes("_l")) {
              questions[index].answer = 0;
            }
            if (element?.id == last_least_question?.id && allMostQuestions?.at(-1)?.answer > 0) {
              console.log("first_least_question,last_least_question-currentQuestion-activeStep-nextPageIdParam", first_least_question, last_least_question, currentQuestion, activeStep, nextPageIdParam)
              getTieBreakers(parseInt(nextPageIdParam), "round1", allMostQuestions.at(-1))
              return;
            }
          })
        }

        if (currentQuestion?.variable?.includes("_l")) {
          return
        }
      }
      else if (!isMost) {
        if (last_least_question?.id == currentQuestion?.id) {
          questions?.forEach((element, index, array) => {
            if (!element.variable?.includes("_l")) {
              questions[index].answer = 0;
            }
            if (element?.id == last_least_question?.id && allLeastQuestions.at(-1)?.answer > 0 && activeStep == questions?.length) {
              // console.log("first_least_question,last_least_question-currentQuestion-activeStep-nextPageIdParam", first_least_question, last_least_question, currentQuestion, activeStep, nextPageIdParam)
              getTieBreakers(parseInt(nextPageIdParam), "round1", allLeastQuestions.at(-1))
              return;
            }
          })
        }

        if (!currentQuestion?.variable?.includes("_l")) {
          return
        }
      }
    }

    let new_answers = [];
    let question = questions?.[step];
    // console.log("step, new_answers, pageId", { step, new_answers, pageId });
    // console.log(pageId)
    question?.answers?.forEach((ans, idx) => {
      if (!removeOptionSelectedInPrevQuestion(ans, question)) new_answers.push(ans);
    })

    // console.log("new_answers-question", new_answers, question)

    if (!backFromTieBreaker && autoSubmit && new_answers.length === 1 && (pageId == 953 || pageId == 954)) {
      moveToNextQuestion(new_answers[0].value, true);
    }
    else {
      return (
        <Question question={questions?.[step]} questions={questions} questionCount={questionCount} results={resultData} id={id} questionAnswered={moveToNextQuestion} currentValue={prevValue} updateTextAnswer={updateTextAnswer} updateCheckboxQuestion={updateCheckboxQuestion} leader={formattedLeader} member={formattedMember} selfUserName={selfUserName}
        />
      );
    }

    // Original filtering logic
    question?.answers?.forEach((ans, idx) => {
      if (!removeOptionSelectedInPrevQuestion(ans, question)) new_answers.push(ans);
    });

    if (!backFromTieBreaker && autoSubmit && new_answers.length === 1) {
      moveToNextQuestion(new_answers[0].value, true);
    }
    else {
      return (
        <Question
          question={questions?.[step]}
          questionCount={questionCount}
          questionAnswered={moveToNextQuestion}
          currentValue={prevValue}
          updateTextAnswer={updateTextAnswer}
          updateCheckboxQuestion={updateCheckboxQuestion}
          leader={formattedLeader}
          member={formattedMember}
          selfUserName={selfUserName}
        />
      );
    }
  }

  const hideMostLeastFor3Way = (step,) => {
    const currentQuestion = questions[step];

    const allMostQuestions = questions?.filter((el) => !el.variable?.includes("_l"));
    const allLeastQuestions = questions?.filter((el) => el.variable?.includes("_l"));
    const first_least_question = allLeastQuestions.at(0)
    const last_least_question = allLeastQuestions.at(-1)
    const leastCount = questions?.length - allMostQuestions?.length;
    // console.log("first_least_question,last_least_question-currentQuestion-activeStep-nextPageIdParam-isMost",first_least_question,last_least_question,currentQuestion,activeStep,nextPageIdParam,isMost)

    if (currentQuestion?.variable?.includes("_l") && isMost) {

      if (first_least_question.id == currentQuestion.id) {
        questions?.forEach((element, index, array) => {
          if (element.variable?.includes("_l")) {
            questions[index].answer = 0;
          }
          if (element.id == last_least_question.id && allMostQuestions.at(-1)?.answer > 0) {
            // console.log("first_least_question,last_least_question-currentQuestion-activeStep-nextPageIdParam",first_least_question,last_least_question,currentQuestion,activeStep,nextPageIdParam)
            getTieBreakers(parseInt(nextPageIdParam), "round1", allMostQuestions.at(-1))
            return;
          }
        })
      }

      return;
    }
    else if (currentQuestion?.variable?.includes("_l") && !isMost) {

      if (last_least_question?.id == currentQuestion?.id) {
        questions?.forEach((element, index, array) => {
          if (!element.variable?.includes("_l")) {
            questions[index].answer = 0;
          }
          if (element?.id == last_least_question?.id && allLeastQuestions.at(-1)?.answer > 0) {
            // console.log("first_least_question,last_least_question-currentQuestion-activeStep-nextPageIdParam",first_least_question,last_least_question,currentQuestion,activeStep,nextPageIdParam)
            getTieBreakers(parseInt(nextPageIdParam), "round1", allLeastQuestions.at(-1))
            return;
          }
        })
      }
    }

    if (!currentQuestion?.variable?.includes("_l") && !isMost) {
      return;
    }
  }

  const getUnselectedOption = (question) => {

    let missingValue = 0;

    let mostArray = [
      { score: variableMapArray["heart_round1_m"], value: 1 },
      { score: variableMapArray["soul_round1_m"], value: 2 },
      { score: variableMapArray["mind_round1_m"], value: 3 },
      { score: variableMapArray["str_round1_m"], value: 4 }
    ];

    let leastArray = [
      { score: variableMapArray["heart_round1_l"], value: 1 },
      { score: variableMapArray["soul_round1_l"], value: 2 },
      { score: variableMapArray["mind_round1_l"], value: 3 },
      { score: variableMapArray["str_round1_l"], value: 4 }
    ];

    if (pageId == "954") {
      // assigning leadership variables in array 

      mostArray = [
        { score: variableMapArray["per_round1_m"], value: 1 },
        { score: variableMapArray["strat_round1_m"], value: 2 },
        { score: variableMapArray["vis_round1_m"], value: 3 },
        { score: variableMapArray["col_round1_m"], value: 4 }
      ];

      leastArray = [
        { score: variableMapArray["per_round1_l"], value: 1 },
        { score: variableMapArray["strat_round1_l"], value: 2 },
        { score: variableMapArray["vis_round1_l"], value: 3 },
        { score: variableMapArray["col_round1_l"], value: 4 }
      ];


    }

    if (pageId == "954" || pageId == "953") {
      let firstOption;
      let secondOption;
      let thirdOption;

      let maxMost = Math.max(...mostArray?.map((el) => el.score));
      firstOption = mostArray?.find((el) => el.score == maxMost)?.value

      let maxLeast = Math.max(...leastArray?.map((el) => el.score));
      secondOption = leastArray?.find((el) => el.score == maxLeast)?.value

      thirdOption = question?.answer;

      missingValue = [1, 2, 3, 4]?.filter((el) => el !== firstOption && el !== secondOption && el !== thirdOption)

      // console.log("tie breaker 2nd round firstoption - secondoption - thirdOption - missingValue - questions", firstOption, secondOption, thirdOption, missingValue, questions)
    }

    return missingValue[0];
  }

  console.log("questions-questions-activestep", questions[activeStep], questions, activeStep)

  // sectionsTemp is a hard coded temporary array just for Sugar Creek assessment. delete it & dont reuse it
  const sectionsTemp = [
    { "id": 1, "order_no": 1, "section": "Staffing" },
    { "id": 2, "order_no": 2, "section": "Resources" },
    { "id": 3, "order_no": 3, "section": "Board" },
    { "id": 4, "order_no": 4, "section": "Body" },
  ];

  if (isLoading) {
    return <div className="container assessment loading"><CircularProgress style={{ color: '#00577D' }} size={60} /></div>
  }




  const getContentTieBreaker = () => {

    const threeWaytieBreakersPageIdArray = [955, 956, 957, 958, 960, 961, 962, 963]
    const twoWaytieBreakersPageIdArray = [959, 966, 967, 968, 969, 970, 964, 971, 972, 973, 974, 975, 985, 986, 987, 989, 990, 978, 984, 996, 997, 998, 999, 1000, 1001]

    // if (threeWaytieBreakersPageIdArray.includes(Number(pageId))) {
    //   return <p className='tie-head'>There's a 3-way tie, let's resolve this for a clearer outcome.</p>;
    // } else if (twoWaytieBreakersPageIdArray.includes(Number(pageId))) {
    //   return <p className='tie-head' >There's a 2-way tie, let's resolve this for a clearer outcome.</p>;
    // }


  }


  const disableBackTemporary = () => {
    if (activeStep > 0 || pageId == "866") {
      return false;
    }

    return true;
  }

  console.log("questionCount", questionsPerSection)
  console.log("questions--", questions)
  // console.log("tiebreakerQuestionCount", tiebreakerQuestionCount)
  console.log("starterMostScores", starterMostScores)
  console.log('currentSectionName', currentSectionName)

  return (
    <>

      <div className="container assessment">
        {/* {windowWidth < 830 ? <>
          <ProgressBarSingle currentProgress={(parseInt(questions?.[activeStep]?.orderNo) - 1)} totalNumOfQuestions={16} />
          <p className="current-section">{currentSectionName}</p>
        </> : <div className="section-progress-top">
          <ProgressBar currentProgress={(parseInt(questions?.[activeStep]?.orderNo) - 1)} questionsPerSection={questionsPerSection} sections={sections} count={16} />
        </div>} */}
        {/* <Box sx={{ width: '100%' }}>
          <Stepper activeStep={activeStep}></Stepper>
        </Box> */}
        <div>
          <div className="steps-container">
            <div>
              <div className="steps">

                {/* {windowWidth > 650 && <div className="spacer"></div>} */}

                {/* // this ProgressBar below has most props as hard coded values specific to Sugar Creek assessment */}
                {/* {
                  <ProgressBar currentProgress={activeStep} questionsPerSection={questionsPerSection} sections={sections} count={4} />} */}

                {windowWidth > 830 ?
                  <>
                    {/* Most of these activeStep & questionCount prop values are changed for Trellis Hub specifically 
                because we need to show only half of the questions as it shows 2 questions under 1 
                so 14 questions instead of 28 */}
                    <ProgressBar pageId={pageId} back={progressBack} next={progressNext} isPauseScreen={isPauseScreen} setProgressBack={setProgressBack} currentQuestion={questions[activeStep]} currentProgress={(activeStep % 2) !== 0 ? activeStep : activeStep + 1} tiebreakerQuestionCount={tiebreakerQuestionCount} questions={questions} questionsPerSection={questionsPerSection} sections={sections} count={questionCount / 2} activeStep={activeStep} getPreviousCompletedQuestions={getPreviousCompletedQuestions} />
                    {/* <ProgressBar currentProgress={(parseInt(questions?.[activeStep]?.orderNo) - 1)} questionsPerSection={questionsPerSection} sections={sections} count={16} /> */}
                  </>
                  : <>
                    <ProgressBarSingle pageId={pageId} back={progressBack} next={progressNext} isPauseScreen={isPauseScreen} currentQuestion={questions[activeStep]} currentProgress={(activeStep % 2) !== 0 ? activeStep : activeStep + 1} tiebreakerQuestionCount={tiebreakerQuestionCount} questions={questions} questionsPerSection={questionsPerSection} sections={sections} count={questionCount / 2} activeStep={activeStep} getPreviousCompletedQuestions={getPreviousCompletedQuestions} currentSectionName={currentSectionName} />

                    {/* <ProgressBarSingle currentProgress={activeStep} totalNumOfQuestions={questionCount} /> */}
                    {/* <ProgressBarSingle currentProgress={(parseInt(questions?.[activeStep]?.orderNo) - 1)} totalNumOfQuestions={16} /> */}
                    {/* <p className="current-section">{currentSectionName}</p> */}
                  </>
                }
                {/* <ProgressBarSingle currentProgress={activeStep} totalNumOfQuestions={questionCount} sections={sections} currentSectionName={currentSectionName} /> */}
                {/* <div className="spacer"></div> */}
                {/* <div className="spacer"></div> */}
                {/* <div className="spacer mobile-spacer"></div> */}
                {/* <div className="spacer mobile-spacer"></div> */}

                {/* <div className="progress-indicator"><strong>{activeStep + 1}</strong>/16</div> */}

                {/* <p className="current-section">{currentQuestionTitle}</p> */}

                {/* <div className="progress-indicator"> */}
                {/* <p className="step-no">{questions?.[activeStep]?.orderNo}</p> */}
                {/* <p className="step-no">{getQuestionNumber(activeStep)}</p> */}
                {/* <p className="total-question-count">{questionCount}</p> */}
                {/* <p className="total-question-count">{questionCount / 2}</p> */}
                {/* </div> */}

                {
                  !isPauseScreen && <>

                    {getContentTieBreaker()}

                    {getStepContent(activeStep)}
                  </>
                }

                {isPauseScreen && <PauseScreen starterMost={starterMostScores} leadershipMost={leadershipMostScores} style={"Heart Starter"} pageId={pageId} hasLeader={hasLeader} member={formattedMember} leader={formattedLeader} selfUserName={selfUserName} userName={userName} />}

              </div>
            </div>
          </div>
          <div className="step-buttons" >
            {/* <Button onClick={prevQuestion}>
              {windowWidth <= 550 ? (
                <><img src={prevArrow} alt="previous button" />&nbsp;&nbsp;</>
                // <>Back</>
              ) : (
                // <>Back</>
                <><img src={prevArrow} alt="previous button" />&nbsp;&nbsp;</>
              )}
            </Button> */}
            {
              // !isPauseScreen &&
              <Button className='custom-back-button' onClick={prevQuestion}>
                {/* <ArrowBackIcon className='custom-back-icon' /> */}
                <img src={leftArrowIcon} alt="" className='imgicon' />
                Back
              </Button>
            }


            {/* {showNextBtn && <Button className="next-btn" onClick={nextQuestion} disabled={checkNextBtnDisabled()}
            // style={nextDisabled()}
            >
              {windowWidth <= 550 ? (
                <span>Next</span>
              ) : (
                <><span>Next</span></>
              )}
            </Button>} */}

            {/* {showNextBtn ? (
              <Button className="custom-next-button" onClick={nextQuestion}>
                Next
                <img src={rightArrowIcon} alt="rightArrowIcon" className='imgicon' />
                // <ArrowForwardIcon className="custom-next-icon" />
              </Button>
            ) : (
              <Button className="custom-next-button overlay" disabled onClick={nextQuestion}>
                Next
                <img src={rightArrowIcon} alt="rightArrowIcon" className='imgicon' />
                // <ArrowForwardIcon className="custom-next-icon" />
              </Button>
            )} */}
            {!isPauseScreen && showNextBtn &&
              <Button className="custom-next-button" onClick={nextQuestion}>
                Next
                <img src={rightArrowIcon} alt="rightArrowIcon" className='imgicon' />
                {/* <ArrowForwardIcon className="custom-next-icon" /> */}
              </Button>
            }

            {isPauseScreen &&
              <Button className="custom-next-button" onClick={nextQuestion}>
                Next
                <img src={rightArrowIcon} alt="rightArrowIcon" className='imgicon' />
              </Button>
            }
          </div>

        </div>
      </div>
    </>
  );
}

export default AssessmentV3;
